(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6186],{

/***/ 94967:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medicine-dictionary/[id]/[keyword]",
      function () {
        return __webpack_require__(7287);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50930);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89961);
/* harmony import */ var _components_atom_icon_arrow_BreadCrumbArrow__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18138);
/* harmony import */ var _constants_zIndex__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31591);
/* harmony import */ var _styles_layout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64952);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78287);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  visibility: ",
        ";\n  position: ",
        ";\n  display: flex;\n\n  @media screen and (max-width: ",
        ") {\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  svg {\n    margin: 0 2px;\n  }\n  p:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px 24px 0;\n  position: relative;\n  z-index: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var CustomBreadCrumbs = function(param) {
    var visible = param.visible, breadCrumbs = param.breadCrumbs;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var onClickBreadCrumb = function(name) {
        (0,_utils_logger__WEBPACK_IMPORTED_MODULE_7__/* .logger */ .kg)({
            pageName: (0,_utils_logger__WEBPACK_IMPORTED_MODULE_7__/* .getPageName */ .j0)(router),
            eventName: "breadcrumb_".concat(name, "_click")
        });
    };
    var breadCrumbsWithHome = [
        {
            label: "홈",
            url: "/",
            logName: "home"
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(breadCrumbs));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        visible: visible,
        id: "breadcrumbs",
        children: breadCrumbsWithHome.map(function(item, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Path, {
                role: "button",
                onClick: function() {
                    return onClickBreadCrumb(item.logName);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: item.url,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                children: item.label
                            })
                        })
                    }),
                    index !== breadCrumbsWithHome.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_icon_arrow_BreadCrumbArrow__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                ]
            }, item.label);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomBreadCrumbs);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d2a85e6a-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
}, function(param) {
    var visible = param.visible;
    return visible ? "visible" : "hidden";
}, function(param) {
    var visible = param.visible;
    return visible ? "static" : "absolute";
}, _styles_layout__WEBPACK_IMPORTED_MODULE_10__/* .Tablet */ .YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI14R;
});
var Path = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d2a85e6a-1"
})(_templateObject1());
var BreadCrumbsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d2a85e6a-2"
})(_templateObject2(), _constants_zIndex__WEBPACK_IMPORTED_MODULE_6__/* .zIndex.BreadCrumb */ .W.BreadCrumb);
CustomBreadCrumbs.Wrapper = BreadCrumbsWrapper;


/***/ }),

/***/ 18138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var BreadCrumbArrow = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.557 2.67311C5.43361 2.69613 5.32045 2.77137 5.25001 2.87723C5.20047 2.95168 5.17989 3.01695 5.17636 3.11082C5.17199 3.22681 5.19204 3.30295 5.25091 3.39399C5.26614 3.41752 5.75502 3.90878 7.5576 5.71185L9.84498 7.99985L7.5576 10.2879C5.75502 12.0909 5.26614 12.5822 5.25091 12.6057C5.19204 12.6968 5.17199 12.7729 5.17636 12.8889C5.17896 12.9579 5.18893 13.0034 5.21347 13.0579C5.26381 13.1698 5.37402 13.27 5.49032 13.3095C5.59721 13.3459 5.73841 13.3389 5.83633 13.2924C5.92155 13.2519 5.7554 13.4152 8.27956 10.891C9.62615 9.54438 10.6303 8.537 10.6468 8.51612C10.8436 8.26702 10.882 7.92846 10.7457 7.64359C10.7179 7.58549 10.6842 7.53099 10.6468 7.48359C10.6303 7.46271 9.62615 6.45533 8.27956 5.10871C6.23381 3.06291 5.93645 2.76711 5.90463 2.74629C5.82035 2.69112 5.75534 2.67081 5.65514 2.66833C5.61039 2.66722 5.58087 2.66866 5.557 2.67311Z",
            fill: "#A9AEB1"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumbArrow);


/***/ }),

/***/ 5786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var YouTubePlayer = function(param) {
    var videoUrl = param.videoUrl;
    var videoId = new URL(videoUrl).searchParams.get("v"); // Extract the video ID from the URL
    if (!videoId) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
        width: "100%",
        height: "100%",
        src: "https://www.youtube.com/embed/".concat(videoId),
        title: "YouTube video player",
        frameBorder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: true
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (YouTubePlayer);


/***/ }),

/***/ 63507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o5": function() { return /* reexport */ libs/* EWebTreatmentRequestLog */.o5; },
  "hK": function() { return /* reexport */ TreatmentMedicineOpenDateModel; },
  "Js": function() { return /* reexport */ libs/* TreatmentRequestLog */.Js; },
  "cV": function() { return /* reexport */ libs/* filteredF2FDaySchedules */.cV; },
  "QB": function() { return /* reexport */ hooks_useDiagnosesByUserV2; },
  "TI": function() { return /* reexport */ hooks_useGetDoctorTreatmentMedicineOpenDate; }
});

// UNUSED EXPORTS: logs

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./src/utils/fetcher.ts
var fetcher = __webpack_require__(8391);
;// CONCATENATED MODULE: ./src/entities/diagnosis/hooks/diagnosis.gql.impl.tsx


var GetDoctorTreatmentMedicineOpenDateDocument = "\n    query GetDoctorTreatmentMedicineOpenDate($doctorId: ID!, $treatmentMedicineId: ID!) {\n  getDoctorTreatmentMedicineOpenDate(\n    doctorId: $doctorId\n    treatmentMedicineId: $treatmentMedicineId\n  ) {\n    date\n  }\n}\n    ";
var useGetDoctorTreatmentMedicineOpenDateQuery = function(variables, options) {
    return (0,useQuery/* useQuery */.a)([
        "GetDoctorTreatmentMedicineOpenDate",
        variables
    ], (0,fetcher/* gqlFetcher */.l3)(GetDoctorTreatmentMedicineOpenDateDocument, "GetDoctorTreatmentMedicineOpenDate", variables), options);
};
useGetDoctorTreatmentMedicineOpenDateQuery.getKey = function(variables) {
    return [
        "GetDoctorTreatmentMedicineOpenDate",
        variables
    ];
};
useGetDoctorTreatmentMedicineOpenDateQuery.fetcher = function(variables, options) {
    return (0,fetcher/* gqlFetcher */.l3)(GetDoctorTreatmentMedicineOpenDateDocument, "GetDoctorTreatmentMedicineOpenDate", variables, options);
};
var DiagnosesByUserV2Document = "\n    query DiagnosesByUserV2($paginationCriteria: PaginationCriteriaInput!) {\n  diagnosesByUserV2(paginationCriteria: $paginationCriteria) {\n    diagnosis {\n      diagnosisForm {\n        id\n        symptom\n      }\n    }\n  }\n}\n    ";
var useDiagnosesByUserV2Query = function(variables, options) {
    return (0,useQuery/* useQuery */.a)([
        "DiagnosesByUserV2",
        variables
    ], (0,fetcher/* gqlFetcher */.l3)(DiagnosesByUserV2Document, "DiagnosesByUserV2", variables), options);
};
useDiagnosesByUserV2Query.getKey = function(variables) {
    return [
        "DiagnosesByUserV2",
        variables
    ];
};
useDiagnosesByUserV2Query.fetcher = function(variables, options) {
    return (0,fetcher/* gqlFetcher */.l3)(DiagnosesByUserV2Document, "DiagnosesByUserV2", variables, options);
};

// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
;// CONCATENATED MODULE: ./src/entities/diagnosis/hooks/useDiagnosesByUserV2.ts


var parseDiagnosesByUserV2 = function(data) {
    return data.diagnosesByUserV2.map(function(diagnosis) {
        return {
            id: diagnosis.diagnosis.diagnosisForm.id,
            symptom: diagnosis.diagnosis.diagnosisForm.symptom ? diagnosis.diagnosis.diagnosisForm.symptom.slice(0, 150) : ""
        };
    });
};
var useDiagnosesByUserV2 = function(param) {
    var _size = param.size, size = _size === void 0 ? 5 : _size;
    var ref = useDiagnosesByUserV2Query({
        paginationCriteria: {
            size: size,
            sort: gql_schema/* SortType.Desc */.ERp.Desc
        }
    }, {
        select: parseDiagnosesByUserV2
    }), tmp = ref.data, recentlyDetailSymptoms = tmp === void 0 ? [] : tmp, isRecentlyDetailSymptomsLoading = ref.isLoading;
    return {
        recentlyDetailSymptoms: recentlyDetailSymptoms,
        recentlyDetailSymptomsCount: recentlyDetailSymptoms.length,
        isRecentlyDetailSymptomsLoading: isRecentlyDetailSymptomsLoading
    };
};
/* harmony default export */ var hooks_useDiagnosesByUserV2 = (useDiagnosesByUserV2);

;// CONCATENATED MODULE: ./src/entities/diagnosis/hooks/useGetDoctorTreatmentMedicineOpenDate.ts


var parseTreatmentMedicineOpenDate = function(data) {
    var ref, ref1;
    if (!(data === null || data === void 0 ? void 0 : (ref = data.getDoctorTreatmentMedicineOpenDate) === null || ref === void 0 ? void 0 : ref.date)) {
        return null;
    }
    return new TreatmentMedicineOpenDateModel({
        openDate: data === null || data === void 0 ? void 0 : (ref1 = data.getDoctorTreatmentMedicineOpenDate) === null || ref1 === void 0 ? void 0 : ref1.date
    });
};
var useGetDoctorTreatmentMedicineOpenDate = function(props) {
    var _treatmentMedicineId;
    var ref = useGetDoctorTreatmentMedicineOpenDateQuery({
        doctorId: props.doctorId,
        treatmentMedicineId: (_treatmentMedicineId = props.treatmentMedicineId) !== null && _treatmentMedicineId !== void 0 ? _treatmentMedicineId : ""
    }, {
        select: parseTreatmentMedicineOpenDate,
        enabled: props.enabled
    }), openDate = ref.data, isOpenDateFetched = ref.isFetched;
    return {
        openDate: openDate,
        isOpenDateFetched: isOpenDateFetched
    };
};
/* harmony default export */ var hooks_useGetDoctorTreatmentMedicineOpenDate = (useGetDoctorTreatmentMedicineOpenDate);

;// CONCATENATED MODULE: ./src/entities/diagnosis/hooks/index.ts




// EXTERNAL MODULE: ./src/entities/diagnosis/libs/index.ts + 1 modules
var libs = __webpack_require__(54674);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
;// CONCATENATED MODULE: ./src/entities/diagnosis/model/TreatmentMedicineOpenDate.ts

var TreatmentMedicineOpenDateModel = /*#__PURE__*/ function() {
    "use strict";
    function TreatmentMedicineOpenDateModel(props) {
        (0,_class_call_check/* default */.Z)(this, TreatmentMedicineOpenDateModel);
        this.props = props;
        this.openDate = props.openDate;
    }
    var _proto = TreatmentMedicineOpenDateModel.prototype;
    _proto.getOpenDate = function getOpenDate() {
        return this.openDate;
    };
    return TreatmentMedicineOpenDateModel;
}();

;// CONCATENATED MODULE: ./src/entities/diagnosis/index.ts






/***/ }),

/***/ 36444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G0": function() { return /* binding */ EWebDiagnosisInflowType; },
/* harmony export */   "Js": function() { return /* binding */ TreatmentRequestLog; },
/* harmony export */   "o5": function() { return /* binding */ EWebTreatmentRequestLog; }
/* harmony export */ });
/* unused harmony export logs */
var TreatmentRequestLog;
(function(TreatmentRequestLog) {
    TreatmentRequestLog["RequestPageIn"] = "request_page_in";
    TreatmentRequestLog["RequestPageInWithTargetDate"] = "request_page_in_with_target_date";
    TreatmentRequestLog["RequestPageInWithoutTargetDate"] = "request_page_in_without_target_date";
    TreatmentRequestLog["RequestClickBookingTime"] = "request_click_booking_time";
    TreatmentRequestLog["RequestSuccessSsn"] = "request_success_ssn";
    TreatmentRequestLog["RequestMoveToPaymentStep"] = "request_move_to_payment_step";
    TreatmentRequestLog["RequestClickNonBenefitCategory"] = "request_click_non_benefit_category";
    TreatmentRequestLog["RequestOpenNonBenefitCategory"] = "request_open_non_benefit_category";
    TreatmentRequestLog["RequestUploadImage"] = "request_upload_image";
    TreatmentRequestLog["RequestPrevStepFromDiagnosis"] = "request_prev_step_from_diagnosis";
    TreatmentRequestLog["RequestPrevStepFromPayment"] = "request_prev_step_from_payment";
    TreatmentRequestLog["RequestClickContinueInModal"] = "request_click_continue_in_modal";
    TreatmentRequestLog["RequestClickStopInModal"] = "request_click_stop_in_modal";
    TreatmentRequestLog["RequestClickAutoAgreementCheck"] = "request_click_auto_agreement_check";
    TreatmentRequestLog["RequestSubmitClick"] = "request_submit_click";
    TreatmentRequestLog["RequestManualOpenCategory"] = "request_manual_open_category";
    TreatmentRequestLog["RequestAutoOpenCategory"] = "request_auto_open_category";
    TreatmentRequestLog["RequestSelectCategory"] = "request_select_category";
    TreatmentRequestLog["RequestPageInQuickMatch"] = "request_page_in_quick_match";
    TreatmentRequestLog["RequestOpenLoadDetailSymptoms"] = "request_open_load_detail_symptoms";
    TreatmentRequestLog["RequestSelectLoadDetailSymptom"] = "request_select_load_detail_symptom";
    TreatmentRequestLog["ImpressedChildInfoSection"] = "impressed_child_info_section";
})(TreatmentRequestLog || (TreatmentRequestLog = {}));
var EWebTreatmentRequestLog;
(function(EWebTreatmentRequestLog) {
    EWebTreatmentRequestLog["CategorySelectItemClick"] = "category_select_item_click";
    EWebTreatmentRequestLog["RequestStepChangeToDiagnosis"] = "web_request_step_change_to_diagnosis";
    EWebTreatmentRequestLog["RequestStepChangeToDoctor"] = "web_request_step_change_to_doctor";
    EWebTreatmentRequestLog["RequestStepChangeToPayment"] = "web_request_step_change_to_payment";
    EWebTreatmentRequestLog["RequestStepChangeToCertificationGuide"] = "web_request_step_change_to_certification_guide";
    EWebTreatmentRequestLog["ClickNextFromDiagnosisStep"] = "click_next_from_diagnosis_step";
    EWebTreatmentRequestLog["ClickCompleteButton"] = "click_complete_button";
    EWebTreatmentRequestLog["ClickTelemedicineRequestInDoctorDetail"] = "click_telemedicine_request_in_doctor_detail";
    EWebTreatmentRequestLog["OpenDoctorDetail"] = "open_doctor_detail";
    EWebTreatmentRequestLog["CloseDoctorDetail"] = "close_doctor_detail";
    EWebTreatmentRequestLog["ClickSelectCardCompany"] = "click_select_card_company";
    EWebTreatmentRequestLog["ClickSelectCard"] = "click_select_card";
    EWebTreatmentRequestLog["ClickAddCreditCard"] = "click_add_credit_card";
    EWebTreatmentRequestLog["ClickAddKakaoPay"] = "click_add_kakao_pay";
    EWebTreatmentRequestLog["ClickOpenInstallment"] = "click_open_installment";
    EWebTreatmentRequestLog["ClickTogglePoint"] = "click_toggle_point";
    EWebTreatmentRequestLog["ClickAgreement"] = "click_agreement";
    EWebTreatmentRequestLog["ClickAllAgreement"] = "click_all_agreement";
    EWebTreatmentRequestLog["ClickAgreementLink"] = "click_agreement_link";
    EWebTreatmentRequestLog["ClickSubmitDiagnosis"] = "click_submit_diagnosis";
    EWebTreatmentRequestLog["ClickCtaButton"] = "click_cta_button";
    EWebTreatmentRequestLog["ClickIdvSheet"] = "click_idv_sheet";
    EWebTreatmentRequestLog["ClickCloseButton"] = "click_close_button";
    EWebTreatmentRequestLog["ClickDoctorPro"] = "click_doctor_pro";
    EWebTreatmentRequestLog["ClickDoctorSort"] = "click_doctor_sort";
    EWebTreatmentRequestLog["ClickReqDoctorSelect"] = "click_req_doctor_select";
    EWebTreatmentRequestLog["ClickRequestTime"] = "click_request_time";
    EWebTreatmentRequestLog["ClickRequestTypeOpen"] = "click_request_type_open";
    EWebTreatmentRequestLog["ClickIdvSheetClose"] = "click_idv_sheet_close";
    EWebTreatmentRequestLog["ClickWebDiagnosisToRequest"] = "click_web_diagnosis_to_request";
    EWebTreatmentRequestLog["ClickWebDiagnosisToCategories"] = "click_web_diagnosis_to_categories";
    EWebTreatmentRequestLog["ClickQuickScheduleMode"] = "click_quick_schedule_mode";
    EWebTreatmentRequestLog["ClickGeneralScheduleMode"] = "click_general_schedule_mode";
    EWebTreatmentRequestLog["ClickDoctorFilterOption"] = "click_doctor_filter_option";
    EWebTreatmentRequestLog["ClickNextFromDoctorFilter"] = "click_next_from_doctor_filter";
    EWebTreatmentRequestLog["ClickLoadMoreDoctorsButton"] = "click_load_more_doctors_button";
})(EWebTreatmentRequestLog || (EWebTreatmentRequestLog = {}));
var logs = {
    request_page_in: "진료신청서 진료신청 페이지 진입",
    request_page_in_with_target_date: "진료신청서 진료신청 페이지 진입(예약 날짜 선택)",
    request_page_in_without_target_date: "진료신청서 진료신청 페이지 진입(예약 날짜 미선택)",
    request_click_auto_agreement_check: "진료신청서 자동 동의 체크 클릭",
    request_click_booking_time: "진료신청서 예약 시간 클릭",
    request_click_continue_in_modal: "진료신청서 이탈 모달 내 계속 작성 클릭",
    request_click_stop_in_modal: "진료신청서 이탈 모달 내 그만두기 클릭",
    request_click_non_benefit_category: "진료신청서 내 비급여 카테고리 클릭",
    request_open_non_benefit_category: "진료신청서 내 비급여 카테고리 오픈",
    request_submit_click: "진료신청서 진료 신청",
    request_move_to_payment_step: "진료신청서 결제 단계로 이동",
    request_prev_step_from_diagnosis: "진료신청서 진료신청 단계에서 이전으로 이동",
    request_prev_step_from_payment: "진료신청서 결제 단계에서 이전으로 이동",
    request_success_ssn: "진료신청서 주민번호 입력 완료",
    request_upload_image: "진료신청서 사진 업로드",
    request_manual_open_category: "진료신청서 카테고리 바텀시트 클릭",
    request_auto_open_category: "진료신청서 카테고리 바텀시트 자동 오픈",
    request_select_category: "진료신청서 카테고리 선택",
    request_page_in_quick_match: "진료신청서 퀵매치 진료신청 페이지 진입",
    request_open_load_detail_symptoms: "진료신청서 증상 불러오기 바텀시트 오픈",
    request_select_load_detail_symptom: "진료신청서 증상 불러오기 상세증상 선택",
    impressed_child_info_section: "진료신청서 아이 정보 섹션 노출"
};
var EWebDiagnosisInflowType;
(function(EWebDiagnosisInflowType) {
    EWebDiagnosisInflowType["QnaDetail"] = "qna_detail";
    EWebDiagnosisInflowType["MagazineDetail"] = "magazine_detail";
    EWebDiagnosisInflowType["FaqDetail"] = "faq_detail";
    EWebDiagnosisInflowType["HospitalDetail"] = "hospital_detail";
    EWebDiagnosisInflowType["MedicineDictionaryDetail"] = "medicine_dictionary_detail";
    EWebDiagnosisInflowType["NonBenefitMap"] = "non_benefit_map";
    EWebDiagnosisInflowType["NonBenefitHome"] = "non_benefit_home";
    EWebDiagnosisInflowType["DiseaseEncyclopediaDetail"] = "disease_encyclopedia_detail";
    EWebDiagnosisInflowType["MainHomeFooter"] = "main_home_footer";
})(EWebDiagnosisInflowType || (EWebDiagnosisInflowType = {}));


/***/ }),

/***/ 54674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o5": function() { return /* reexport */ constants/* EWebTreatmentRequestLog */.o5; },
  "Js": function() { return /* reexport */ constants/* TreatmentRequestLog */.Js; },
  "cV": function() { return /* reexport */ filteredF2FDaySchedules; }
});

// UNUSED EXPORTS: logs

// EXTERNAL MODULE: ./src/entities/diagnosis/libs/constants.ts
var constants = __webpack_require__(36444);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/isSameOrAfter.js
var isSameOrAfter = __webpack_require__(79212);
var isSameOrAfter_default = /*#__PURE__*/__webpack_require__.n(isSameOrAfter);
;// CONCATENATED MODULE: ./src/entities/diagnosis/libs/f2fDaySchedule.ts



dayjs_min_default().extend((isSameOrAfter_default()));
var filteredF2FDaySchedules = function(days, dateToSelect) {
    if (!dateToSelect) return days;
    var base = dayjs_min_default()(dateToSelect);
    var filtered = days.filter(function(d) {
        return dayjs_min_default()(d.targetDate).isSameOrAfter(base, "day");
    });
    return (0,_to_consumable_array/* default */.Z)(filtered);
};

;// CONCATENATED MODULE: ./src/entities/diagnosis/libs/index.ts





/***/ }),

/***/ 72115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90581);

var MedicineDictionaryModel = function MedicineDictionaryModel(data) {
    "use strict";
    var _this = this;
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, MedicineDictionaryModel);
    this.getPublicId = function() {
        return _this.publicId;
    };
    this.getMedicinePictogramImages = function() {
        var _medicinePictogramImages;
        return (_medicinePictogramImages = _this.basicInfo.medicinePictogramImages) !== null && _medicinePictogramImages !== void 0 ? _medicinePictogramImages : [];
    };
    this.getSimplifiedName = function() {
        return _this.basicInfo.simplifiedName;
    };
    this.getPharmaceuticalEffectLiteracy = function() {
        return _this.basicInfo.pharmaceuticalEffectLiteracy;
    };
    this.getIndications = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.indications) !== null && ref1 !== void 0 ? ref1 : [];
    };
    this.getDosages = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.dosages) !== null && ref1 !== void 0 ? ref1 : [];
    };
    this.getDosageHtml = function() {
        var ref;
        return (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.dosageHtml;
    };
    this.getSideEffects = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.sideEffects) !== null && ref1 !== void 0 ? ref1 : [];
    };
    this.getEthicalType = function() {
        var ref;
        return (ref = _this.classificationInfo) === null || ref === void 0 ? void 0 : ref.ethicalType;
    };
    this.getCompanyName = function() {
        var ref;
        return (ref = _this.companyInfo) === null || ref === void 0 ? void 0 : ref.companyName;
    };
    this.getFormattedIngredientName = function() {
        var ref;
        return (ref = _this.ingredientInfo) === null || ref === void 0 ? void 0 : ref.formattedIngredientName;
    };
    this.getStorages = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.storages) !== null && ref1 !== void 0 ? ref1 : [];
    };
    this.getCaution = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.cautions) !== null && ref1 !== void 0 ? ref1 : [];
    };
    this.getInteractionHtml = function() {
        var ref;
        return (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.interactionHtml;
    };
    this.getVideoLink = function() {
        var ref;
        return (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.videoLink;
    };
    this.getBasicInfoName = function() {
        return _this.basicInfo.name;
    };
    this.getWholeSummary = function() {
        var ref;
        return (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.wholeSummary;
    };
    this.getRepresentativeImage = function() {
        var ref;
        var _medicineImage, ref1;
        return (ref1 = (_medicineImage = _this.basicInfo.medicineImage) !== null && _medicineImage !== void 0 ? _medicineImage : (ref = _this.packagingInfo) === null || ref === void 0 ? void 0 : ref.image) !== null && ref1 !== void 0 ? ref1 : undefined;
    };
    this.getMedicineGuideIndications = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.indications) !== null && ref1 !== void 0 ? ref1 : [];
    };
    this.getMedicineGuideDosages = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.dosages) !== null && ref1 !== void 0 ? ref1 : [];
    };
    this.getMedicineGuideSideEffects = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.sideEffects) !== null && ref1 !== void 0 ? ref1 : [];
    };
    this.getMedicineGuideCautions = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.cautions) !== null && ref1 !== void 0 ? ref1 : [];
    };
    this.getMedicineGuideStorages = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.storages) !== null && ref1 !== void 0 ? ref1 : [];
    };
    this.getMedicineGuideInteractionHtml = function() {
        var ref;
        return (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.interactionHtml;
    };
    this.id = data.id;
    this.publicId = data.publicId;
    this.basicInfo = data.basicInfo;
    this.classificationInfo = data.classificationInfo;
    this.companyInfo = data.companyInfo;
    this.ingredientInfo = data.ingredientInfo;
    this.medicineGuide = data.medicineGuide;
    this.packagingInfo = data.packagingInfo;
};
/* harmony default export */ __webpack_exports__["Z"] = (MedicineDictionaryModel);


/***/ }),

/***/ 68534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z6": function() { return /* binding */ sanitizeHtml; },
/* harmony export */   "at": function() { return /* binding */ createMedicineDictionaryDetailUrl; },
/* harmony export */   "pT": function() { return /* binding */ createMedicineDictionaryDetailUrlWithKeyword; }
/* harmony export */ });
/* unused harmony exports getMedicineDictionaryImageUrl, createMedicineDictionaryRedirectUrl */
/* harmony import */ var _shared_utils_format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64214);
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70138);


var sanitizeHtml = function(html) {
    // tbody가 p 태그 안에 있는 경우를 처리
    var sanitized = html.replace(/<p><tbody>/g, "<table><tbody>");
    sanitized = sanitized.replace(/<\/tbody><\/p>/g, "</tbody></table>");
    // 테이블 스타일링을 위한 클래스 추가
    sanitized = sanitized.replace(/<table>/g, '<table class="w-full border-collapse border border-gray-200 my-4 rounded-lg overflow-hidden">');
    sanitized = sanitized.replace(/<td/g, '<td class="border border-gray-200 px-4 py-3 text-center bg-white"');
    sanitized = sanitized.replace(/<tr>/g, '<tr class="hover:bg-gray-50">');
    // 첫 번째 행(헤더)에 다른 스타일 적용
    sanitized = sanitized.replace(/(<tr class="hover:bg-gray-50">[\s\S]*?<\/tr>)/, function(match) {
        return match.replace("bg-white", "bg-gray-100 font-medium");
    });
    return sanitized;
};
var getMedicineDictionaryImageUrl = function(image, packagingInfoImage) {
    var ref;
    return (ref = image !== null && image !== void 0 ? image : packagingInfoImage) !== null && ref !== void 0 ? ref : undefined;
};
var createMedicineDictionaryDetailUrl = function(medicineDictionary) {
    if (!medicineDictionary) {
        return "";
    }
    var publicId = medicineDictionary.getPublicId();
    var keyword = medicineDictionary.getBasicInfoName() || medicineDictionary.getSimplifiedName();
    var encodedKeyword = (0,_shared_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .formatKeywordForUrl */ .Z)(keyword);
    return "".concat(_types_common__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.MEDICINE_DICTIONARY.DETAIL.path */ .Z6.MEDICINE_DICTIONARY.DETAIL.path, "/").concat(publicId, "/").concat(encodedKeyword);
};
var createMedicineDictionaryDetailUrlWithKeyword = function(publicId, keyword) {
    var encodedKeyword = (0,_shared_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .formatKeywordForUrl */ .Z)(keyword);
    return "".concat(_types_common__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.MEDICINE_DICTIONARY.DETAIL.path */ .Z6.MEDICINE_DICTIONARY.DETAIL.path, "/").concat(publicId, "/").concat(encodedKeyword);
};
var extractKeywordFromMedicineData = function(medicineData) {
    return medicineData.basicInfo.name || medicineData.basicInfo.simplifiedName;
};
var createMedicineDictionaryRedirectUrl = function(publicId, medicineData) {
    var keyword = extractKeywordFromMedicineData(medicineData);
    var formattedKeyword = formatKeywordForUrl(keyword);
    var encodedKeyword = encodeURIComponent(formattedKeyword);
    return "".concat(ROUTES.MEDICINE_DICTIONARY.DETAIL.path, "/").concat(publicId, "/").concat(encodedKeyword);
};


/***/ }),

/***/ 22548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KY": function() { return /* binding */ useGetMagazinesQuery; },
/* harmony export */   "Kq": function() { return /* binding */ useGetMagazinesBannerQuery; },
/* harmony export */   "_O": function() { return /* binding */ useGetMagazinesCurationQuery; },
/* harmony export */   "d7": function() { return /* binding */ useGetKeywordSearchMagazineCursorPageQuery; },
/* harmony export */   "jp": function() { return /* binding */ useGetMagazineDetailQuery; }
/* harmony export */ });
/* unused harmony exports GetMagazinesBannerDocument, GetMagazinesDocument, GetMagazineDetailDocument, InsertMagazineLikeDocument, useInsertMagazineLikeMutation, DeleteMagazineLikeDocument, useDeleteMagazineLikeMutation, GetRandomMagazinesDocument, useGetRandomMagazinesQuery, GetMagazinesCurationDocument, GetKeywordSearchMagazineCursorPageDocument */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36492);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48228);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);


var GetMagazinesBannerDocument = "\n    query GetMagazinesBanner($magazineCursorPageRequestInput: MagazineCursorPageRequestInput!) {\n  magazineCursorPage(request: $magazineCursorPageRequestInput) {\n    elements {\n      magazinePid\n      mobileTitle\n      titleImageUrl\n    }\n  }\n}\n    ";
var useGetMagazinesBannerQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetMagazinesBanner",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetMagazinesBannerDocument, "GetMagazinesBanner", variables), options);
};
useGetMagazinesBannerQuery.getKey = function(variables) {
    return [
        "GetMagazinesBanner",
        variables
    ];
};
useGetMagazinesBannerQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetMagazinesBannerDocument, "GetMagazinesBanner", variables, options);
};
var GetMagazinesDocument = "\n    query GetMagazines($magazineCursorPageRequestInput: MagazineCursorPageRequestInput!) {\n  magazineCursorPage(request: $magazineCursorPageRequestInput) {\n    elements {\n      createdAt\n      magazinePid\n      title\n      titleImageUrl\n      mobileTitle\n      mobileDescription\n      description\n      author {\n        affiliatedInstitutionName\n        authorId\n        authorType\n        externalLinkUrl\n        name\n        profileImageUrl\n        professionalFields {\n          name\n        }\n      }\n    }\n    pivot\n  }\n}\n    ";
var useGetMagazinesQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetMagazines",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetMagazinesDocument, "GetMagazines", variables), options);
};
useGetMagazinesQuery.getKey = function(variables) {
    return [
        "GetMagazines",
        variables
    ];
};
useGetMagazinesQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetMagazinesDocument, "GetMagazines", variables, options);
};
var GetMagazineDetailDocument = "\n    query getMagazineDetail($magazinePid: ID!) {\n  magazineV2(magazinePid: $magazinePid) {\n    author {\n      affiliatedInstitutionName\n      authorId\n      authorType\n      authorPublicId\n      externalLinkUrl\n      name\n      profileImageUrl\n      professionalFields {\n        name\n      }\n      profileDescription\n      careers {\n        content\n        isRepresentative\n        careerType\n      }\n    }\n    content\n    contentType\n    mobileContent\n    createdAt\n    tagNames\n    description\n    likeCount\n    magazinePid\n    questionCategoryId\n    title\n    mobileTitle\n    mobileDescription\n    titleImageUrl\n    footnote\n    isLikedByMe\n    hasJapanese\n    hospital {\n      name\n      publicId\n      roadAddress\n      profileImages {\n        url\n      }\n    }\n    bottomButtonType\n    tags {\n      coreCategories {\n        coreId\n        coreType\n      }\n      magazinePid\n      name\n      tagId\n      tagType\n    }\n    banner {\n      id\n      magazineId\n      externalUrl\n      title\n      description\n      imageUrl\n      buttonPhrase\n    }\n  }\n}\n    ";
var useGetMagazineDetailQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "getMagazineDetail",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetMagazineDetailDocument, "getMagazineDetail", variables), options);
};
useGetMagazineDetailQuery.getKey = function(variables) {
    return [
        "getMagazineDetail",
        variables
    ];
};
useGetMagazineDetailQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetMagazineDetailDocument, "getMagazineDetail", variables, options);
};
var InsertMagazineLikeDocument = "\n    mutation InsertMagazineLike($magazinePid: ID!) {\n  insertMagazineLike(magazinePid: $magazinePid)\n}\n    ";
var useInsertMagazineLikeMutation = function(options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)([
        "InsertMagazineLike"
    ], function(variables) {
        return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(InsertMagazineLikeDocument, "InsertMagazineLike", variables)();
    }, options);
};
useInsertMagazineLikeMutation.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(InsertMagazineLikeDocument, "InsertMagazineLike", variables, options);
};
var DeleteMagazineLikeDocument = "\n    mutation DeleteMagazineLike($magazinePid: ID!) {\n  deleteMagazineLike(magazinePid: $magazinePid)\n}\n    ";
var useDeleteMagazineLikeMutation = function(options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)([
        "DeleteMagazineLike"
    ], function(variables) {
        return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(DeleteMagazineLikeDocument, "DeleteMagazineLike", variables)();
    }, options);
};
useDeleteMagazineLikeMutation.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(DeleteMagazineLikeDocument, "DeleteMagazineLike", variables, options);
};
var GetRandomMagazinesDocument = "\n    query GetRandomMagazines($randomMagazineRequestInput: RandomMagazineRequestInput!) {\n  randomMagazines(request: $randomMagazineRequestInput) {\n    createdAt\n    magazinePid\n    titleImageUrl\n    mobileTitle\n    mobileDescription\n    author {\n      authorId\n      authorType\n    }\n  }\n}\n    ";
var useGetRandomMagazinesQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetRandomMagazines",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetRandomMagazinesDocument, "GetRandomMagazines", variables), options);
};
useGetRandomMagazinesQuery.getKey = function(variables) {
    return [
        "GetRandomMagazines",
        variables
    ];
};
useGetRandomMagazinesQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetRandomMagazinesDocument, "GetRandomMagazines", variables, options);
};
var GetMagazinesCurationDocument = "\n    query GetMagazinesCuration($magazineCursorPageRequestInput: MagazineCursorPageRequestInput!) {\n  magazineCursorPage(request: $magazineCursorPageRequestInput) {\n    elements {\n      magazinePid\n      mobileTitle\n      mobileDescription\n      titleImageUrl\n      createdAt\n    }\n  }\n}\n    ";
var useGetMagazinesCurationQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetMagazinesCuration",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetMagazinesCurationDocument, "GetMagazinesCuration", variables), options);
};
useGetMagazinesCurationQuery.getKey = function(variables) {
    return [
        "GetMagazinesCuration",
        variables
    ];
};
useGetMagazinesCurationQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetMagazinesCurationDocument, "GetMagazinesCuration", variables, options);
};
var GetKeywordSearchMagazineCursorPageDocument = "\n    query GetKeywordSearchMagazineCursorPage($request: KeywordSearchMagazineCursorPageRequestInput!) {\n  keywordSearchMagazineCursorPage(request: $request) {\n    elements {\n      createdAt\n      magazinePid\n      title\n      description\n      titleImageUrl\n      mobileTitle\n      mobileDescription\n      content\n      author {\n        affiliatedInstitutionName\n        authorId\n        authorType\n        externalLinkUrl\n        name\n        profileImageUrl\n        professionalFields {\n          name\n        }\n      }\n    }\n    pivot\n  }\n}\n    ";
var useGetKeywordSearchMagazineCursorPageQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetKeywordSearchMagazineCursorPage",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetKeywordSearchMagazineCursorPageDocument, "GetKeywordSearchMagazineCursorPage", variables), options);
};
useGetKeywordSearchMagazineCursorPageQuery.getKey = function(variables) {
    return [
        "GetKeywordSearchMagazineCursorPage",
        variables
    ];
};
useGetKeywordSearchMagazineCursorPageQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetKeywordSearchMagazineCursorPageDocument, "GetKeywordSearchMagazineCursorPage", variables, options);
};


/***/ }),

/***/ 16708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "me": function() { return /* binding */ useMedicineDictionaryItemByPublicIdQuery; },
/* harmony export */   "vi": function() { return /* binding */ usePopularMedicineDictionaryItemsQuery; }
/* harmony export */ });
/* unused harmony exports MedicineDictionaryItemByPublicIdDocument, PopularMedicineDictionaryItemsDocument */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36492);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);


var MedicineDictionaryItemByPublicIdDocument = "\n    query MedicineDictionaryItemByPublicId($publicId: String!) {\n  medicineDictionaryItemByPublicId(publicId: $publicId) {\n    id\n    publicId\n    basicInfo {\n      name\n      simplifiedName\n      pharmaceuticalEffectLiteracy\n      medicineImage\n      medicinePictogramImages\n    }\n    classificationInfo {\n      ethicalType\n    }\n    companyInfo {\n      companyName\n    }\n    ingredientInfo {\n      formattedIngredientName\n    }\n    medicineGuide {\n      interactionHtml\n      indications\n      dosages\n      dosageHtml\n      sideEffects\n      cautions\n      storages\n      videoLink\n    }\n    packagingInfo {\n      image\n    }\n  }\n}\n    ";
var useMedicineDictionaryItemByPublicIdQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "MedicineDictionaryItemByPublicId",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(MedicineDictionaryItemByPublicIdDocument, "MedicineDictionaryItemByPublicId", variables), options);
};
useMedicineDictionaryItemByPublicIdQuery.getKey = function(variables) {
    return [
        "MedicineDictionaryItemByPublicId",
        variables
    ];
};
useMedicineDictionaryItemByPublicIdQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(MedicineDictionaryItemByPublicIdDocument, "MedicineDictionaryItemByPublicId", variables, options);
};
var PopularMedicineDictionaryItemsDocument = "\n    query PopularMedicineDictionaryItems {\n  popularMedicineDictionaryItems {\n    id\n    publicId\n    basicInfo {\n      name\n      simplifiedName\n      pharmaceuticalEffectLiteracy\n      medicineImage\n    }\n    medicineGuide {\n      wholeSummary\n    }\n    packagingInfo {\n      image\n    }\n  }\n}\n    ";
var usePopularMedicineDictionaryItemsQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(variables === undefined ? [
        "PopularMedicineDictionaryItems"
    ] : [
        "PopularMedicineDictionaryItems",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(PopularMedicineDictionaryItemsDocument, "PopularMedicineDictionaryItems", variables), options);
};
usePopularMedicineDictionaryItemsQuery.getKey = function(variables) {
    return variables === undefined ? [
        "PopularMedicineDictionaryItems"
    ] : [
        "PopularMedicineDictionaryItems",
        variables
    ];
};
usePopularMedicineDictionaryItemsQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(PopularMedicineDictionaryItemsDocument, "PopularMedicineDictionaryItems", variables, options);
};


/***/ }),

/***/ 58104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ magazine_useGetKeywordSearchMagazineInfinite; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./src/hooks/magazine/mobile/magazine.gql.impl.tsx
var magazine_gql_impl = __webpack_require__(22548);
// EXTERNAL MODULE: ./src/types/magazine.ts
var magazine = __webpack_require__(45162);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
// EXTERNAL MODULE: ./src/types/search.ts
var search = __webpack_require__(50728);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(59403);
;// CONCATENATED MODULE: ./src/hooks/search/magazine/useGetKeywordSearchMagazineInfiniteQuery.ts




var useGetKeywordSearchMagazineInfiniteQuery = function(variables, queryOptions) {
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)([
        "GetKeywordSearchMagazineCursorPage",
        variables
    ], function(param) {
        var pageParam = param.pageParam;
        return magazine_gql_impl/* useGetKeywordSearchMagazineCursorPageQuery.fetcher */.d7.fetcher({
            request: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables.request), {
                pivot: pageParam
            })
        })();
    }, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queryOptions), {
        getNextPageParam: function(lastPage) {
            var size = variables.request.size;
            if (lastPage.keywordSearchMagazineCursorPage.elements.length < size) {
                return undefined;
            }
            return lastPage.keywordSearchMagazineCursorPage.pivot;
        }
    }));
};
/* harmony default export */ var magazine_useGetKeywordSearchMagazineInfiniteQuery = (useGetKeywordSearchMagazineInfiniteQuery);

;// CONCATENATED MODULE: ./src/hooks/search/magazine/useGetKeywordSearchMagazineInfinite.ts










var MAGAZINE_SIZE = 20;
var parseAuthorType = function(authorType) {
    switch(authorType){
        case gql_schema/* AuthorType.Doctor */.Tqb.Doctor:
            return search/* EAuthorType.Doctor */.nc.Doctor;
        case gql_schema/* AuthorType.Nurse */.Tqb.Nurse:
            return search/* EAuthorType.Nurse */.nc.Nurse;
        case gql_schema/* AuthorType.Ai */.Tqb.Ai:
            return search/* EAuthorType.Ai */.nc.Ai;
        case gql_schema/* AuthorType.GeneralEditor */.Tqb.GeneralEditor:
            return search/* EAuthorType.GeneralEditor */.nc.GeneralEditor;
        case gql_schema/* AuthorType.MedicalProfessionalEditor */.Tqb.MedicalProfessionalEditor:
            return search/* EAuthorType.MedicalProfessionalEditor */.nc.MedicalProfessionalEditor;
    }
};
var parseSearchResultMagazineVo = function(data) {
    if (data) {
        return data.flatMap(function(page) {
            return page.keywordSearchMagazineCursorPage.elements;
        }).map(function(magazine) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, magazine), {
                createdDate: "".concat(dayjs_min_default()(magazine.createdAt).format("YYYY.MM.DD")),
                author: magazine.author ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, magazine.author), {
                    authorType: parseAuthorType(magazine.author.authorType)
                }) : undefined
            });
        });
    }
    return [];
};
var useGetKeywordSearchMagazineInfinite = function(param) {
    var keyword = param.keyword, _size = param.size, size = _size === void 0 ? MAGAZINE_SIZE : _size, contentType = param.contentType, _enabled = param.enabled, enabled = _enabled === void 0 ? true : _enabled;
    var ref = magazine_useGetKeywordSearchMagazineInfiniteQuery({
        request: {
            contentType: contentType,
            keyword: keyword,
            size: size
        }
    }, {
        select: function(data) {
            return {
                pages: parseSearchResultMagazineVo(data.pages),
                pageParams: data.pageParams
            };
        },
        enabled: enabled && !!keyword && keyword.length > 0
    }), magazinesData = ref.data, isMagazinesLoading = ref.isLoading, hasMagazinesNextPage = ref.hasNextPage, fetchMagazinesNextPage = ref.fetchNextPage;
    var magazines = (magazinesData === null || magazinesData === void 0 ? void 0 : magazinesData.pages.flatMap(function(magazine) {
        return magazine;
    })) || [];
    return {
        magazines: magazines,
        magazinesData: magazinesData,
        isMagazinesLoading: isMagazinesLoading,
        hasMagazinesNextPage: hasMagazinesNextPage,
        fetchMagazinesNextPage: fetchMagazinesNextPage
    };
};
/* harmony default export */ var magazine_useGetKeywordSearchMagazineInfinite = (useGetKeywordSearchMagazineInfinite);
useGetKeywordSearchMagazineInfinite.prefetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, params) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.prefetchInfiniteQuery(magazine_gql_impl/* useGetKeywordSearchMagazineCursorPageQuery.getKey */.d7.getKey({
                            request: params
                        }), magazine_gql_impl/* useGetKeywordSearchMagazineCursorPageQuery.fetcher */.d7.fetcher({
                            request: params
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient, params) {
        return _ref.apply(this, arguments);
    };
}();
var getNonBenefitHomeArticleParams = function(keyword) {
    return {
        keyword: keyword,
        size: 5,
        contentType: magazine/* MagazineType.ARTICLE */.rL.ARTICLE
    };
};
var prefetchArticle = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, params) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.prefetchInfiniteQuery(magazine_gql_impl/* useGetKeywordSearchMagazineCursorPageQuery.getKey */.d7.getKey({
                            request: (0,_object_spread/* default */.Z)({}, getNonBenefitHomeArticleParams(params.keyword))
                        }), magazine_gql_impl/* useGetKeywordSearchMagazineCursorPageQuery.fetcher */.d7.fetcher({
                            request: (0,_object_spread/* default */.Z)({}, getNonBenefitHomeArticleParams(params.keyword))
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function prefetchArticle(queryClient, params) {
        return _ref.apply(this, arguments);
    };
}();
useGetKeywordSearchMagazineInfinite.getNonBenefitHomeArticleParams = getNonBenefitHomeArticleParams;
useGetKeywordSearchMagazineInfinite.prefetchArticle = prefetchArticle;


/***/ }),

/***/ 7287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _keyword_; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./src/components/atom/CustomBreadCrumbs.tsx
var CustomBreadCrumbs = __webpack_require__(12429);
// EXTERNAL MODULE: ./src/components/atom/buttons/StickyButton.tsx
var StickyButton = __webpack_require__(91707);
// EXTERNAL MODULE: ./src/components/atom/icon/layout/HealthMedicalMedicines.tsx
var HealthMedicalMedicines = __webpack_require__(71305);
// EXTERNAL MODULE: ./src/components/common/ClickLogger.tsx
var ClickLogger = __webpack_require__(53157);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/molecules/sticky-app-header/index.tsx + 3 modules
var sticky_app_header = __webpack_require__(83025);
// EXTERNAL MODULE: ./src/entities/diagnosis/index.ts + 5 modules
var diagnosis = __webpack_require__(63507);
// EXTERNAL MODULE: ./src/entities/diagnosis/libs/constants.ts
var constants = __webpack_require__(36444);
// EXTERNAL MODULE: ./src/utils/style.ts
var style = __webpack_require__(76666);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./public/images/medicine-dictionary/mailChatBubbleTypingOval.svg
var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgMailChatBubbleTypingOval = function SvgMailChatBubbleTypingOval(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#mailChatBubbleTypingOval_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M17.178 1.928a11.92 11.92 0 0 0-11.303.512 11.92 11.92 0 0 0-4.04 16.453L.132 23.428a.857.857 0 0 0 .955 1.145L7.028 23.5a11.921 11.921 0 0 0 10.15-21.571Z",
    fill: "#D0EBFF"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m6.475 12.667-.001-.003-.001-.002H6.47l-.003-.001h-.002l-.002.001v.002l-.002.003.001.002.001.002h.002l.002.002.003-.001.002-.001v-.002l.002-.002Zm-1.715 0a1.708 1.708 0 1 1 3.417 0 1.708 1.708 0 0 1-3.417 0Zm7.246 0v-.003l-.002-.002h-.001L12 12.66h-.003l-.001.001-.001.002-.001.003v.002l.002.002h.001l.003.002.003-.001.001-.001.001-.002.001-.002Zm-1.714 0a1.708 1.708 0 1 1 3.416 0 1.708 1.708 0 0 1-3.416 0Zm7.245-.003v.005l-.001.002h-.002l-.002.002-.003-.001-.002-.001v-.002l-.001-.002v-.003l.001-.002h.002l.003-.001h.002l.002.001.001.002Zm-.005-1.705a1.708 1.708 0 1 0 0 3.416 1.708 1.708 0 0 0 0-3.416Z",
    fill: "#228BE6"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "mailChatBubbleTypingOval_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .667)",
    d: "M0 0h24v24H0z"
  })))));
};
/* harmony default export */ var mailChatBubbleTypingOval = (SvgMailChatBubbleTypingOval);
;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/MedicineBasicInfo.tsx



var MedicineBasicInfo = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,style.cn)("flex flex-col gap-[20px] px-[24px] py-[28px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mailChatBubbleTypingOval, {
                        className: "shrink-0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "typography-ui-19sb shrink-1 select-text text-gray-700",
                        children: [
                            props.simplifiedName,
                            ", 어떤 약인가요?"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-[2px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-[10px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "typography-ui-15m flex-shrink-0 select-text text-gray-400",
                                children: "성분"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "typography-ui-15r flex-shrink-1 select-text text-gray-900",
                                children: props.formattedIngredientName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-[10px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "typography-ui-15m flex-shrink-0 select-text text-gray-400",
                                children: "구분"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "typography-ui-15r flex-shrink-1 select-text text-gray-900",
                                children: props.ethicalType
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-[10px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "typography-ui-15m flex-shrink-0 select-text text-gray-400",
                                children: "업체"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "typography-ui-15r flex-shrink-1 select-text text-gray-900",
                                children: props.companyName
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ui_MedicineBasicInfo = (MedicineBasicInfo);

;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/MedicineDictionaryInnerSectionDivider.tsx

var MedicineDictionaryInnerSectionDivider = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-[1px] w-full bg-gray-40"
    });
};
/* harmony default export */ var ui_MedicineDictionaryInnerSectionDivider = (MedicineDictionaryInnerSectionDivider);

;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/MedicineDictionarySectionDivider.tsx

var MedicineDictionarySectionDivider = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-[16px] w-full bg-gray-30"
    });
};
/* harmony default export */ var ui_MedicineDictionarySectionDivider = (MedicineDictionarySectionDivider);

// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
// EXTERNAL MODULE: ./src/entities/medicine-dictionary/util/index.ts
var util = __webpack_require__(68534);
// EXTERNAL MODULE: ../../libs/ui/dist/index.es.js
var index_es = __webpack_require__(4601);
;// CONCATENATED MODULE: ./public/images/medicine-dictionary/healthMedicalMedicines.svg
var healthMedicalMedicines_g, healthMedicalMedicines_defs;
function healthMedicalMedicines_extends() { return healthMedicalMedicines_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, healthMedicalMedicines_extends.apply(null, arguments); }

var SvgHealthMedicalMedicines = function SvgHealthMedicalMedicines(props) {
  return /*#__PURE__*/react.createElement("svg", healthMedicalMedicines_extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), healthMedicalMedicines_g || (healthMedicalMedicines_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#healthMedicalMedicines_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M15.93 10.94a4.696 4.696 0 1 1 6.641 6.64l-5.69 5.69a4.696 4.696 0 1 1-6.64-6.641l5.689-5.69Z",
    fill: "#EF990D"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M19.25 9.564c-1.245 0-2.44.495-3.32 1.376l-2.845 2.844 6.641 6.641 2.845-2.844a4.697 4.697 0 0 0-3.32-8.017Z",
    fill: "#F4B54F"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M6.653 13.972a6.652 6.652 0 1 0 0-13.305 6.652 6.652 0 0 0 0 13.305Z",
    fill: "#339AF0"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.086 8.39h13.133a6.697 6.697 0 0 0 0-2.142H.086a6.7 6.7 0 0 0 0 2.142Z",
    fill: "#86C6FF"
  }))), healthMedicalMedicines_defs || (healthMedicalMedicines_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "healthMedicalMedicines_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .667)",
    d: "M0 0h24v24H0z"
  })))));
};
/* harmony default export */ var healthMedicalMedicines = (SvgHealthMedicalMedicines);
;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/MedicineGuideDosage.tsx







var MedicineGuideDosage = function(props) {
    var ref;
    var shouldShowDosageHtml = props.dosageHtml && props.dosageHtml.length > 0;
    var shouldShowButton = props.dosageHtml && props.dosageHtml.length > 0;
    var ref1 = (0,react.useState)(false), isDescriptionExpended = ref1[0], setIsDescriptionExpended = ref1[1];
    var toggleDescriptionExpended = function() {
        setIsDescriptionExpended(!isDescriptionExpended);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,style.cn)("flex flex-col gap-[20px] px-[24px] py-[28px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(healthMedicalMedicines, {
                        className: "shrink-0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: (0,style.cn)("typography-ui-19sb shrink-1 select-text text-gray-700"),
                        children: [
                            props.simplifiedName,
                            ", 용법/용량"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,style.cn)("flex flex-col "),
                children: [
                    (ref = props.dosages) === null || ref === void 0 ? void 0 : ref.map(function(dosageInfo) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col gap-[12px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "flex flex-col gap-[12px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: (0,style.cn)([
                                        "typography-ui-15r select-text text-gray-700",
                                        "relative pl-[20px]",
                                        'before:absolute before:top-[10px] before:left-[6px] before:h-[4px] before:w-[4px] before:rounded-full before:bg-gray-700 before:content-[""]',
                                        "flex gap-[8px]", 
                                    ]),
                                    children: dosageInfo
                                }, "dosageInfo-".concat(dosageInfo))
                            })
                        }, "dosage-".concat(dosageInfo));
                    }),
                    shouldShowDosageHtml && isDescriptionExpended && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,style.cn)([
                            "mt-[20px] flex w-full flex-col gap-[12px]",
                            "typography-ui-15r select-text text-gray-700",
                            "rounded-[12px] bg-gray-20 p-[20px]", 
                        ]),
                        dangerouslySetInnerHTML: {
                            __html: (0,util/* sanitizeHtml */.Z6)(props.dosageHtml || "")
                        }
                    })
                ]
            }),
            shouldShowButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                buttonStyle: "outlined",
                buttonColor: "gray",
                size: "m",
                className: (0,style.cn)([
                    "w-full transition-all duration-300 ease-in-out",
                    "hover:scale-[1.02]active:scale-[0.98]"
                ]),
                type: "button",
                onClick: toggleDescriptionExpended,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "ease flex items-center gap-2 transition-all duration-300",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "typography-ui-15sb text-gray-600",
                            children: isDescriptionExpended ? "접기" : "자세히 보기"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,style.cn)([
                                "ease transition-transform duration-300",
                                isDescriptionExpended ? "rotate-180" : "rotate-0", 
                            ]),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                name: "keyboard_arrow_down",
                                size: 20
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ui_MedicineGuideDosage = (MedicineGuideDosage);

;// CONCATENATED MODULE: ./public/images/medicine-dictionary/spark.svg
var spark_g, spark_defs;
function spark_extends() { return spark_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, spark_extends.apply(null, arguments); }

var SvgSpark = function SvgSpark(props) {
  return /*#__PURE__*/react.createElement("svg", spark_extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), spark_g || (spark_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#spark_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "m8.821 5.943 2.407 6.294 6.292 2.407-6.292 2.405-2.407 6.294-2.407-6.294L.12 14.644l6.294-2.407 2.407-6.294Z",
    fill: "#FFE066"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m19.14 2.106 1.345 3.516L24 6.967 20.485 8.31l-1.344 3.516-1.345-3.516-3.516-1.343 3.516-1.345 1.345-3.516Z",
    fill: "#FCC419"
  }))), spark_defs || (spark_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "spark_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .667)",
    d: "M0 0h24v24H0z"
  })))));
};
/* harmony default export */ var spark = (SvgSpark);
;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/MedicineGuideIndication.tsx



var MedicineGuideIndication = function(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,style.cn)("flex flex-col gap-[20px] px-[24px] py-[28px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spark, {
                        className: "shrink-0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "typography-ui-19sb shrink-1 select-text text-gray-700",
                        children: [
                            props.simplifiedName,
                            " 효능/효과"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col gap-[20px]",
                children: (ref = props.indications) === null || ref === void 0 ? void 0 : ref.map(function(efficacy, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col gap-[12px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "flex flex-col gap-[12px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "typography-ui-15r select-text text-gray-700",
                                children: efficacy
                            }, "efficacy-".concat(efficacy))
                        })
                    }, "efficacy-".concat(efficacy || index));
                })
            })
        ]
    });
};
/* harmony default export */ var ui_MedicineGuideIndication = (MedicineGuideIndication);

// EXTERNAL MODULE: ./src/components/common/link-tag/index.tsx
var link_tag = __webpack_require__(1967);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/MedicineGuideMagazine.tsx






var MedicineGuideMagazine = function(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,style.cn)("flex flex-col gap-[20px] px-[24px] py-[28px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                className: (0,style.cn)("typography-ui-19sb text-gray-700"),
                children: [
                    props.simplifiedName,
                    " 관련 건강 매거진"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex w-full flex-col ",
                children: (ref = props.magazines) === null || ref === void 0 ? void 0 : ref.map(function(magazine, index, array) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(link_tag/* default */.Z, {
                                href: "".concat(common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazine.magazinePid),
                                onClickNavigateToScreen: props.onClickMagazine(magazine),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex w-full items-center justify-between gap-[12px] rounded-[12px] py-[20px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col gap-[4px]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "typography-ui-17sb text-gray-700",
                                                    children: magazine.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "typography-ui-15r text-gray-500",
                                                    children: magazine.description
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "typography-ui-13r text-gray-300",
                                                    children: magazine.createdDate
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: magazine.titleImageUrl,
                                                alt: "magazine-image",
                                                className: "h-auto w-[96px] rounded-[8px]"
                                            })
                                        })
                                    ]
                                })
                            }, "magazine-".concat(magazine.magazinePid, "_").concat(index)),
                            index < array.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[1px] w-full bg-gray-50"
                            })
                        ]
                    });
                })
            }),
            props.shouldShowMoreButton() && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                buttonStyle: "outlined",
                buttonColor: "gray",
                size: "m",
                className: (0,style.cn)([
                    "w-full transition-all duration-300 ease-in-out",
                    "hover:scale-[1.02] active:scale-[0.98]"
                ]),
                type: "button",
                onClick: props.onClickMore,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "typography-ui-15sb text-gray-600",
                            children: "더 보기"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                            name: "keyboard_arrow_right",
                            size: 20
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ui_MedicineGuideMagazine = (MedicineGuideMagazine);

;// CONCATENATED MODULE: ./public/images/medicine-dictionary/alertWarningTriangle.svg
var _path, _path2;
function alertWarningTriangle_extends() { return alertWarningTriangle_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, alertWarningTriangle_extends.apply(null, arguments); }

var SvgAlertWarningTriangle = function SvgAlertWarningTriangle(props) {
  return /*#__PURE__*/react.createElement("svg", alertWarningTriangle_extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.667a2.144 2.144 0 0 0-1.908 1.166l-.003.006-7.86 15.719a2.149 2.149 0 0 0 .088 2.086 2.145 2.145 0 0 0 1.82 1.023h15.726a2.144 2.144 0 0 0 1.908-3.108l-7.86-15.72-.003-.006A2.144 2.144 0 0 0 12 2.666Z",
    fill: "#F03E3E"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.136 9.924c0-.493-.508-.894-1.136-.894-.627 0-1.136.4-1.136.894v4.293c0 .493.508.894 1.136.894.628 0 1.136-.4 1.136-.895V9.925ZM12 19.94c1.004 0 1.818-.64 1.818-1.43 0-.79-.814-1.431-1.818-1.431s-1.818.64-1.818 1.43c0 .79.814 1.431 1.818 1.431Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var alertWarningTriangle = (SvgAlertWarningTriangle);
;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/MedicineGuideSideEffect.tsx







var MedicineGuideSideEffect = function(props) {
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), isCautionExpanded = ref3[0], setIsCautionExpanded = ref3[1];
    var shouldShowPictogramArea = props.medicinePictogramImages && props.medicinePictogramImages.length > 0;
    var shouldShowInteractionHtml = props.interactionHtml && props.interactionHtml.length > 0;
    var shouldShowButton = props.interactionHtml && props.interactionHtml.length > 0;
    var toggleCautionExpanded = function() {
        setIsCautionExpanded(!isCautionExpanded);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,style.cn)("flex flex-col gap-[20px] px-[24px] py-[28px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(alertWarningTriangle, {
                        className: "shrink-0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: (0,style.cn)("typography-ui-19sb shrink-1 select-text text-gray-700"),
                        children: [
                            props.simplifiedName,
                            ", 부작용 및 주의사항"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-[32px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-[8px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "typography-ui-15m select-text text-gray-400",
                                children: "부작용"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col gap-[12px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "flex flex-col gap-[12px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "typography-ui-15r select-text text-gray-700",
                                        children: (ref = props.sideEffects) === null || ref === void 0 ? void 0 : ref.map(function(sideEffect) {
                                            return sideEffect;
                                        }).join(", ")
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-[8px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "typography-ui-15m select-text text-gray-400",
                                children: "주의사항"
                            }),
                            (ref1 = props.cautions) === null || ref1 === void 0 ? void 0 : ref1.map(function(label, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-col gap-[12px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "flex flex-col gap-[12px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: (0,style.cn)([
                                                "typography-ui-15r select-text text-gray-700",
                                                "relative pl-[20px]",
                                                'before:absolute before:top-[10px] before:left-[6px] before:h-[4px] before:w-[4px] before:rounded-full before:bg-gray-700 before:content-[""]',
                                                "flex gap-[8px]", 
                                            ]),
                                            children: label
                                        }, "caution-".concat(label))
                                    })
                                }, "caution-".concat(label || index));
                            })
                        ]
                    })
                ]
            }),
            shouldShowPictogramArea && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex gap-[12px] overflow-x-scroll md:overflow-x-hidden",
                children: (ref2 = props.medicinePictogramImages) === null || ref2 === void 0 ? void 0 : ref2.map(function(image, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: image,
                        alt: "medicine-pictogram",
                        className: "h-auto w-[54px] object-contain"
                    }, "medicine-pictogram-".concat(index));
                })
            }),
            shouldShowInteractionHtml && isCautionExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,style.cn)([
                    "mt-[20px] flex w-full flex-col",
                    "typography-ui-15r select-text text-gray-700",
                    "rounded-[12px] bg-gray-20 px-[20px] py-[16px]", 
                ]),
                dangerouslySetInnerHTML: {
                    __html: (0,util/* sanitizeHtml */.Z6)(props.interactionHtml || "")
                }
            }),
            shouldShowButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                buttonStyle: "outlined",
                buttonColor: "gray",
                size: "m",
                className: (0,style.cn)([
                    "w-full transition-all duration-300 ease-in-out",
                    "hover:scale-[1.02] active:scale-[0.98]"
                ]),
                type: "button",
                onClick: toggleCautionExpanded,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-2 transition-all duration-300 ease-in-out",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "typography-ui-15sb text-gray-600",
                            children: isCautionExpanded ? "접기" : "자세히 보기"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,style.cn)([
                                "transition-transform duration-300 ease-in-out",
                                isCautionExpanded ? "rotate-180" : "rotate-0", 
                            ]),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                name: "keyboard_arrow_down",
                                size: 20
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ui_MedicineGuideSideEffect = (MedicineGuideSideEffect);

;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/MedicineGuideSource.tsx


var SOURCE_LIST = [
    {
        name: "커넥트디아이",
        url: "https://www.connectdi.com"
    },
    {
        name: "식품의약품안전처",
        url: "https://uvoice.mfds.go.kr"
    }, 
];
var MedicineGuideSource = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex flex-col gap-[20px] px-[24px] py-[28px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "typography-ui-19sb text-gray-700",
                children: "정보 출처"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "flex flex-col gap-[12px]",
                children: SOURCE_LIST.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: (0,style.cn)([
                            "typography-ui-15r text-gray-700",
                            "relative pl-[20px]",
                            'before:absolute before:top-[10px] before:left-[6px] before:h-[4px] before:w-[4px] before:rounded-full before:bg-gray-700 before:content-[""]',
                            "flex gap-[8px]", 
                        ]),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "typography-ui-15m text-gray-500",
                                children: item.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "cursor-pointer text-gray-300 underline decoration-gray-300 underline-offset-auto",
                                onClick: props.onClickSource(item.url),
                                children: item.url
                            })
                        ]
                    }, "source-".concat(item.name));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "typography-ui-13r text-gray-400",
                children: [
                    "본 콘텐츠의 저작권은 저자 또는 제공처에 있으며, 이를 무단 이용하는 경우 저작권법 등에 따라 법적책임을 질수 있습니다.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "외부저작권자가 제공한 콘텐츠는 닥터나우의 입장과 다를 수 있습니다."
                ]
            })
        ]
    });
};
/* harmony default export */ var ui_MedicineGuideSource = (MedicineGuideSource);

;// CONCATENATED MODULE: ./public/images/medicine-dictionary/wrappedGift.svg
var wrappedGift_path, wrappedGift_path2, _path3, _path4;
function wrappedGift_extends() { return wrappedGift_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, wrappedGift_extends.apply(null, arguments); }

var SvgWrappedGift = function SvgWrappedGift(props) {
  return /*#__PURE__*/react.createElement("svg", wrappedGift_extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), wrappedGift_path || (wrappedGift_path = /*#__PURE__*/react.createElement("path", {
    d: "m3 6.667 2.2-2.64a1 1 0 0 1 .768-.36h12.497a1 1 0 0 1 .832.445L21 6.666H3Z",
    fill: "#FFC96E"
  })), wrappedGift_path2 || (wrappedGift_path2 = /*#__PURE__*/react.createElement("path", {
    d: "m8 6.667 1.111-3h6l.889 3H8Z",
    fill: "#8C5543"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M3 6.667h18v13.5a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-13.5Z",
    fill: "#FFCE7C"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M8 6.667h8v7.443a.5.5 0 0 1-.75.433L12.233 12.8a.5.5 0 0 0-.474-.014l-3.035 1.518A.5.5 0 0 1 8 13.858V6.665Z",
    fill: "#A56953"
  })));
};
/* harmony default export */ var wrappedGift = (SvgWrappedGift);
;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/MedicineGuideStorage.tsx



var MedicineGuideStorage = function(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,style.cn)("flex flex-col gap-[20px] px-[24px] py-[28px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(wrappedGift, {
                        className: "shrink-0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: (0,style.cn)("typography-ui-19sb shrink-1 select-text text-gray-700"),
                        children: [
                            props.simplifiedName,
                            " 보관 방법"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "flex flex-col gap-[8px]",
                children: (ref = props.storages) === null || ref === void 0 ? void 0 : ref.map(function(storage) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (0,style.cn)([
                            "typography-ui-15r select-text text-gray-700",
                            "relative pl-[20px]",
                            'before:absolute before:top-[10px] before:left-[6px] before:h-[4px] before:w-[4px] before:rounded-full before:bg-gray-700 before:content-[""]',
                            "flex gap-[8px]", 
                        ]),
                        children: storage
                    }, "storage-".concat(storage));
                })
            })
        ]
    });
};
/* harmony default export */ var ui_MedicineGuideStorage = (MedicineGuideStorage);

// EXTERNAL MODULE: ./src/components/molecules/YouTubePlayer.tsx
var YouTubePlayer = __webpack_require__(5786);
;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/MedicineGuideVideoInfo.tsx



var MedicineGuideVideoInfo = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,style.cn)("flex flex-col gap-[20px] px-[24px] py-[28px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (0,style.cn)("typography-ui-19sb select-text text-gray-700"),
                children: "영상으로 이해하는 복약정보"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,style.cn)("typography-ui-15r select-text text-gray-700"),
                children: props.videoLink && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative aspect-video w-full overflow-hidden rounded-lg border border-gray-200",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(YouTubePlayer/* default */.Z, {
                        videoUrl: props.videoLink
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ui_MedicineGuideVideoInfo = (MedicineGuideVideoInfo);

;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/MedicineImageWithName.tsx


var MedicineImageWithName = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,style.cn)([
            "flex flex-col gap-[32px] px-[24px] py-[28px] md:flex-row md:gap-[32px]"
        ]),
        suppressHydrationWarning: true,
        children: [
            props.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: props.image,
                alt: props.imageAlt,
                className: "w-full rounded-[20px] object-contain md:w-[220px]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col justify-center gap-[2px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "typography-ui-15r select-text text-gray-400",
                        children: props.pharmaceuticalEffectLiteracy
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "typography-ui-19sb select-text text-gray-900",
                        children: props.name
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ui_MedicineImageWithName = (MedicineImageWithName);

// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
// EXTERNAL MODULE: ./src/types/header.ts
var header = __webpack_require__(37072);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/templates/mobile/communication/common/AppInstallTopBanner.tsx
var AppInstallTopBanner = __webpack_require__(42411);
;// CONCATENATED MODULE: ./src/components/templates/medicine-dictionary/MedicineDictionaryDetailTemplate.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 8px;\n  gap: 8px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



























var MedicineDictionaryDetailTemplate = function(param) {
    var viewModel = param.viewModel, topBannerViewModel = param.topBannerViewModel, client = param.client;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24;
    var shouldShowBreadCrumbs = client.clientType === app/* ClientType.WEB */.B.WEB;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            client.clientType === app/* ClientType.MOBILE_WEB */.B.MOBILE_WEB && topBannerViewModel.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.StickyHeader */.Z.StickyHeader, {
                style: {
                    top: 60
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppInstallTopBanner/* default */.Z, {
                    onLogEvent: viewModel.onClickTopCta,
                    onClickClose: topBannerViewModel.hideBanner,
                    content: "web_content_bnr_service",
                    trackingInfo: {
                        campaign: "web_medicine_dictionary",
                        contentId: (ref = viewModel.medicineDictionaryItemByPublicId) === null || ref === void 0 ? void 0 : ref.getPublicId(),
                        contentTitle: (ref1 = viewModel.medicineDictionaryItemByPublicId) === null || ref1 === void 0 ? void 0 : ref1.getSimplifiedName()
                    }
                })
            }),
            client.isWebView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.StickyHeader */.Z.StickyHeader, {
                type: header/* HeaderType.WithMobileHeader */.n.WithMobileHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sticky_app_header/* default */.Z, {
                    title: (ref2 = viewModel.medicineDictionaryItemByPublicId) === null || ref2 === void 0 ? void 0 : ref2.getBasicInfoName(),
                    hasLeftBackButton: true,
                    onClickBackButton: RNPlugins/* historyBack */.$i
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                suppressHydrationWarning: true,
                children: shouldShowBreadCrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBreadCrumbs/* default.Wrapper */.Z.Wrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBreadCrumbs/* default */.Z, {
                        visible: true,
                        breadCrumbs: viewModel.breadCrumbs
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineImageWithName, {
                        image: (ref3 = viewModel.medicineDictionaryItemByPublicId) === null || ref3 === void 0 ? void 0 : ref3.getRepresentativeImage(),
                        imageAlt: (ref4 = viewModel.medicineDictionaryItemByPublicId) === null || ref4 === void 0 ? void 0 : ref4.getSimplifiedName(),
                        name: (ref5 = viewModel.medicineDictionaryItemByPublicId) === null || ref5 === void 0 ? void 0 : ref5.getBasicInfoName(),
                        pharmaceuticalEffectLiteracy: (ref6 = viewModel.medicineDictionaryItemByPublicId) === null || ref6 === void 0 ? void 0 : ref6.getPharmaceuticalEffectLiteracy()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineBasicInfo, {
                        simplifiedName: (ref7 = viewModel.medicineDictionaryItemByPublicId) === null || ref7 === void 0 ? void 0 : ref7.getSimplifiedName(),
                        formattedIngredientName: (ref8 = viewModel.medicineDictionaryItemByPublicId) === null || ref8 === void 0 ? void 0 : ref8.getFormattedIngredientName(),
                        ethicalType: (ref9 = viewModel.medicineDictionaryItemByPublicId) === null || ref9 === void 0 ? void 0 : ref9.getEthicalType(),
                        companyName: (ref10 = viewModel.medicineDictionaryItemByPublicId) === null || ref10 === void 0 ? void 0 : ref10.getCompanyName()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineDictionaryInnerSectionDivider, {}),
                    viewModel.shouldShowMedicineGuideIndication() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineGuideIndication, {
                                simplifiedName: (ref11 = viewModel.medicineDictionaryItemByPublicId) === null || ref11 === void 0 ? void 0 : ref11.getSimplifiedName(),
                                indications: (ref12 = viewModel.medicineDictionaryItemByPublicId) === null || ref12 === void 0 ? void 0 : ref12.getIndications()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineDictionaryInnerSectionDivider, {})
                        ]
                    }),
                    viewModel.shouldShowMedicineGuideDosage() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineGuideDosage, {
                                simplifiedName: (ref13 = viewModel.medicineDictionaryItemByPublicId) === null || ref13 === void 0 ? void 0 : ref13.getSimplifiedName(),
                                dosages: (ref14 = viewModel.medicineDictionaryItemByPublicId) === null || ref14 === void 0 ? void 0 : ref14.getDosages(),
                                dosageHtml: (ref15 = viewModel.medicineDictionaryItemByPublicId) === null || ref15 === void 0 ? void 0 : ref15.getDosageHtml()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineDictionaryInnerSectionDivider, {})
                        ]
                    }),
                    viewModel.shouldShowMedicineGuideSideEffect() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineGuideSideEffect, {
                                simplifiedName: (ref16 = viewModel.medicineDictionaryItemByPublicId) === null || ref16 === void 0 ? void 0 : ref16.getSimplifiedName(),
                                sideEffects: (ref17 = viewModel.medicineDictionaryItemByPublicId) === null || ref17 === void 0 ? void 0 : ref17.getSideEffects(),
                                interactionHtml: (ref18 = viewModel.medicineDictionaryItemByPublicId) === null || ref18 === void 0 ? void 0 : ref18.getInteractionHtml(),
                                cautions: (ref19 = viewModel.medicineDictionaryItemByPublicId) === null || ref19 === void 0 ? void 0 : ref19.getCaution(),
                                medicinePictogramImages: (ref20 = viewModel.medicineDictionaryItemByPublicId) === null || ref20 === void 0 ? void 0 : ref20.getMedicinePictogramImages()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineDictionaryInnerSectionDivider, {})
                        ]
                    }),
                    viewModel.shouldShowMedicineGuideStorage() && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineGuideStorage, {
                        simplifiedName: (ref21 = viewModel.medicineDictionaryItemByPublicId) === null || ref21 === void 0 ? void 0 : ref21.getSimplifiedName(),
                        storages: (ref22 = viewModel.medicineDictionaryItemByPublicId) === null || ref22 === void 0 ? void 0 : ref22.getStorages()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineDictionarySectionDivider, {}),
                    viewModel.shouldShowMagazine() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineGuideMagazine, {
                                simplifiedName: (ref23 = viewModel.medicineDictionaryItemByPublicId) === null || ref23 === void 0 ? void 0 : ref23.getSimplifiedName(),
                                magazines: viewModel.magazines,
                                onClickMagazine: viewModel.onClickMagazine,
                                onClickMore: viewModel.onClickMore,
                                shouldShowMoreButton: viewModel.shouldShowMagazineMoreButton
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineDictionarySectionDivider, {})
                        ]
                    }),
                    viewModel.shouldShowVideoInfo() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineGuideVideoInfo, {
                                videoLink: (ref24 = viewModel.medicineDictionaryItemByPublicId) === null || ref24 === void 0 ? void 0 : ref24.getVideoLink()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineDictionarySectionDivider, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineGuideSource, {
                        onClickSource: viewModel.onClickSource
                    }),
                    viewModel.shouldShowCtaButton() && /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyButtonWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                                    params: {
                                        eventName: diagnosis/* EWebTreatmentRequestLog.ClickWebDiagnosisToCategories */.o5.ClickWebDiagnosisToCategories,
                                        payload: {
                                            inflowType: constants/* EWebDiagnosisInflowType.MedicineDictionaryDetail */.G0.MedicineDictionaryDetail
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                        type: "button",
                                        buttonStyle: "contained",
                                        buttonColor: "primary",
                                        size: "xl",
                                        className: "w-full",
                                        onClick: viewModel.onClickCtaButton,
                                        children: "닥터나우로 편하게 진료받기"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventTextArea, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HealthMedicalMedicines/* default */.Z, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventTextWrapper, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventText, {
                                                    children: "오늘 "
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightedEventText, {
                                                    children: "1,379명"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventText, {
                                                    children: "이 비대면 진료로 처방받았어요"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var StickyButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-157e1c97-0"
})(_templateObject());
var EventTextArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-157e1c97-1"
})(_templateObject1());
var EventText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-157e1c97-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI15M, ";\n    color: ").concat(theme.color.gray500, ";\n  ");
});
var HighlightedEventText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-157e1c97-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI15SB, ";\n    color: ").concat(theme.color.primary700, ";\n  ");
});
var EventTextWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-157e1c97-4"
})(_templateObject4());
/* harmony default export */ var medicine_dictionary_MedicineDictionaryDetailTemplate = (MedicineDictionaryDetailTemplate);

// EXTERNAL MODULE: ./src/hooks/cuj/useAppInstallTopBanner.tsx
var useAppInstallTopBanner = __webpack_require__(40573);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ./src/constants/pixel.ts
var pixel = __webpack_require__(4380);
// EXTERNAL MODULE: ./src/types/magazine.ts
var magazine = __webpack_require__(45162);
// EXTERNAL MODULE: ./src/types/search.ts
var search = __webpack_require__(50728);
// EXTERNAL MODULE: ./src/utils/pixel/pixel.ts
var pixel_pixel = __webpack_require__(5863);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./src/hooks/search/magazine/useGetKeywordSearchMagazineInfinite.ts + 1 modules
var useGetKeywordSearchMagazineInfinite = __webpack_require__(58104);
// EXTERNAL MODULE: ./src/hooks/useNavigate.ts + 1 modules
var useNavigate = __webpack_require__(85180);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./src/entities/medicine-dictionary/model/medicineDictionary.model.ts
var medicineDictionary_model = __webpack_require__(72115);
// EXTERNAL MODULE: ./src/hooks/medicine-dictionary/medicine-dictionary.gql.impl.tsx
var medicine_dictionary_gql_impl = __webpack_require__(16708);
;// CONCATENATED MODULE: ./src/hooks/medicine-dictionary/useMedicineDictionaryItemByPublicId.ts




var parseMedicineDictionary = function(data) {
    var _medicineImage, _formattedIngredientName, _image;
    return new medicineDictionary_model/* default */.Z({
        id: data.medicineDictionaryItemByPublicId.id,
        publicId: data.medicineDictionaryItemByPublicId.publicId,
        basicInfo: {
            name: data.medicineDictionaryItemByPublicId.basicInfo.name,
            simplifiedName: data.medicineDictionaryItemByPublicId.basicInfo.simplifiedName,
            pharmaceuticalEffectLiteracy: data.medicineDictionaryItemByPublicId.basicInfo.pharmaceuticalEffectLiteracy,
            medicineImage: (_medicineImage = data.medicineDictionaryItemByPublicId.basicInfo.medicineImage) !== null && _medicineImage !== void 0 ? _medicineImage : undefined,
            medicinePictogramImages: data.medicineDictionaryItemByPublicId.basicInfo.medicinePictogramImages
        },
        classificationInfo: {
            ethicalType: data.medicineDictionaryItemByPublicId.classificationInfo.ethicalType
        },
        companyInfo: {
            companyName: data.medicineDictionaryItemByPublicId.companyInfo.companyName
        },
        ingredientInfo: {
            formattedIngredientName: (_formattedIngredientName = data.medicineDictionaryItemByPublicId.ingredientInfo.formattedIngredientName) !== null && _formattedIngredientName !== void 0 ? _formattedIngredientName : undefined
        },
        medicineGuide: {
            indications: data.medicineDictionaryItemByPublicId.medicineGuide.indications,
            dosages: data.medicineDictionaryItemByPublicId.medicineGuide.dosages,
            dosageHtml: data.medicineDictionaryItemByPublicId.medicineGuide.dosageHtml,
            sideEffects: data.medicineDictionaryItemByPublicId.medicineGuide.sideEffects,
            cautions: data.medicineDictionaryItemByPublicId.medicineGuide.cautions,
            storages: data.medicineDictionaryItemByPublicId.medicineGuide.storages,
            videoLink: data.medicineDictionaryItemByPublicId.medicineGuide.videoLink,
            interactionHtml: data.medicineDictionaryItemByPublicId.medicineGuide.interactionHtml
        },
        packagingInfo: {
            image: (_image = data.medicineDictionaryItemByPublicId.packagingInfo.image) !== null && _image !== void 0 ? _image : undefined
        }
    });
};
var useMedicineDictionaryItemByPublicId = function(publicId) {
    var ref = (0,medicine_dictionary_gql_impl/* useMedicineDictionaryItemByPublicIdQuery */.me)({
        publicId: publicId
    }, {
        enabled: !!publicId,
        select: parseMedicineDictionary,
        staleTime: 1000 * 60 * 5
    }), medicineDictionaryItemByPublicId = ref.data;
    return {
        medicineDictionaryItemByPublicId: medicineDictionaryItemByPublicId
    };
};
/* harmony default export */ var medicine_dictionary_useMedicineDictionaryItemByPublicId = (useMedicineDictionaryItemByPublicId);
useMedicineDictionaryItemByPublicId.prefetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, publicId) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                queryClient.prefetchQuery({
                    queryKey: medicine_dictionary_gql_impl/* useMedicineDictionaryItemByPublicIdQuery.getKey */.me.getKey({
                        publicId: publicId
                    }),
                    queryFn: medicine_dictionary_gql_impl/* useMedicineDictionaryItemByPublicIdQuery.fetcher */.me.fetcher({
                        publicId: publicId
                    }),
                    staleTime: 1000 * 60 * 5
                })
            ];
        });
    });
    return function(queryClient, publicId) {
        return _ref.apply(this, arguments);
    };
}();
useMedicineDictionaryItemByPublicId.getKey = function(publicId) {
    return medicine_dictionary_gql_impl/* useMedicineDictionaryItemByPublicIdQuery.getKey */.me.getKey({
        publicId: publicId
    });
};

;// CONCATENATED MODULE: ./src/hooks/medicine-dictionary/useMedicineDictionaryDetailViewModel.ts












var MAGAZINE_SIZE = 3;
var useMedicineDictionaryDetailViewModel = function(param) {
    var client = param.client, publicId = param.publicId;
    var router = (0,next_router.useRouter)();
    var navigate = (0,useNavigate/* default */.Z)();
    var id = publicId || router.query.id;
    var medicineDictionaryItemByPublicId = medicine_dictionary_useMedicineDictionaryItemByPublicId(id).medicineDictionaryItemByPublicId;
    var ref;
    var magazines = (0,useGetKeywordSearchMagazineInfinite/* default */.Z)({
        keyword: (ref = medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getSimplifiedName()) !== null && ref !== void 0 ? ref : "",
        size: MAGAZINE_SIZE,
        contentType: magazine/* MagazineType.ARTICLE */.rL.ARTICLE,
        enabled: !!(medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getBasicInfoName())
    }).magazines;
    var breadCrumbs = (0,react.useMemo)(function() {
        var ref;
        return [
            {
                label: "의약품 사전",
                url: "".concat(common/* ROUTES.MEDICINE_DICTIONARY.HOME.path */.Z6.MEDICINE_DICTIONARY.HOME.path),
                logName: "medicine_dictionary"
            },
            {
                label: (ref = medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getBasicInfoName()) !== null && ref !== void 0 ? ref : "",
                url: "".concat((0,util/* createMedicineDictionaryDetailUrl */.at)(medicineDictionaryItemByPublicId)),
                logName: "medicine_dictionary_detail"
            }, 
        ];
    }, [
        medicineDictionaryItemByPublicId
    ]);
    var shouldShowMedicineGuideIndication = function() {
        var ref;
        return !!(medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getMedicineGuideIndications()) && ((ref = medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getMedicineGuideIndications()) === null || ref === void 0 ? void 0 : ref.length) > 0;
    };
    var shouldShowMedicineGuideDosage = function() {
        var ref;
        return !!(medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getMedicineGuideDosages()) && ((ref = medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getMedicineGuideDosages()) === null || ref === void 0 ? void 0 : ref.length) > 0;
    };
    var shouldShowMedicineGuideSideEffect = function() {
        var ref;
        return !!(medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getMedicineGuideSideEffects()) && ((ref = medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getMedicineGuideSideEffects()) === null || ref === void 0 ? void 0 : ref.length) > 0;
    };
    var shouldShowMedicineGuideStorage = function() {
        var ref;
        return !!(medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getMedicineGuideStorages()) && ((ref = medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getMedicineGuideStorages()) === null || ref === void 0 ? void 0 : ref.length) > 0;
    };
    var shouldShowMagazine = function() {
        return magazines.length > 0;
    };
    var shouldShowVideoInfo = function() {
        return !!(medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getVideoLink());
    };
    var shouldShowCtaButton = function() {
        if (client.isWebView) {
            return false;
        }
        return true;
    };
    var onClickCtaButton = function() {
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.BottomCtaClick */.$.BottomCtaClick, (0,_object_spread/* default */.Z)({}, (medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getPharmaceuticalEffectLiteracy()) && {
            category: medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getPharmaceuticalEffectLiteracy()
        }, (medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getSimplifiedName()) && {
            drug: medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getSimplifiedName()
        }));
        navigate.navigateToTelemedicineCategoriesScreen();
    };
    var onClickMagazine = function(magazine) {
        return function() {
            navigate.navigateToMagazineDetail({
                magazinePid: magazine.magazinePid
            });
        };
    };
    var onClickMore = function() {
        var ref;
        navigate.navigateToSearchHomeScreen({
            keyword: (ref = medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getSimplifiedName()) !== null && ref !== void 0 ? ref : "",
            tab: search/* EIntegratedSearchTabType.Magazine */.DD.Magazine
        });
    };
    var onClickSource = function(url) {
        return function() {
            if (client.isWebView) {
                navigate.navigateToExternalBrowser({
                    url: url
                });
                return;
            }
            window.open(url, "_blank");
        };
    };
    var shouldShowMagazineMoreButton = function() {
        if (!(medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getSimplifiedName())) {
            return false;
        }
        if (magazines.length < 3) {
            return false;
        }
        return !/[/@$!%*#?&]/.test(medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getSimplifiedName());
    };
    var onClickTopCta = function() {
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.TopCtaClick */.$.TopCtaClick, (0,_object_spread/* default */.Z)({}, (medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getPharmaceuticalEffectLiteracy()) && {
            category: medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getPharmaceuticalEffectLiteracy()
        }, (medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getSimplifiedName()) && {
            drug: medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getSimplifiedName()
        }));
    };
    (0,react.useEffect)(function() {
        if (medicineDictionaryItemByPublicId) {
            pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.PageIn */.$.PageIn, (0,_object_spread/* default */.Z)({}, (medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getPharmaceuticalEffectLiteracy()) && {
                category: medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getPharmaceuticalEffectLiteracy()
            }, (medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getSimplifiedName()) && {
                drug: medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getSimplifiedName()
            }));
        }
    }, [
        medicineDictionaryItemByPublicId
    ]);
    return {
        breadCrumbs: breadCrumbs,
        medicineDictionaryItemByPublicId: medicineDictionaryItemByPublicId,
        magazines: magazines,
        shouldShowMedicineGuideIndication: shouldShowMedicineGuideIndication,
        shouldShowMedicineGuideDosage: shouldShowMedicineGuideDosage,
        shouldShowMedicineGuideSideEffect: shouldShowMedicineGuideSideEffect,
        shouldShowMedicineGuideStorage: shouldShowMedicineGuideStorage,
        shouldShowMagazine: shouldShowMagazine,
        shouldShowVideoInfo: shouldShowVideoInfo,
        shouldShowCtaButton: shouldShowCtaButton,
        onClickCtaButton: onClickCtaButton,
        onClickMagazine: onClickMagazine,
        onClickSource: onClickSource,
        shouldShowMagazineMoreButton: shouldShowMagazineMoreButton,
        onClickTopCta: onClickTopCta,
        onClickMore: onClickMore
    };
};
/* harmony default export */ var medicine_dictionary_useMedicineDictionaryDetailViewModel = (useMedicineDictionaryDetailViewModel);

// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/pages/medicine-dictionary/[id]/[keyword]/index.tsx
// PageDescription: 의약품 정보 상세 페이지 (키워드 포함)







var createMedicineDictionaryDetailLdJson = function(medicineDetail) {
    var ref;
    if (!medicineDetail) {
        return {};
    }
    return {
        "@context": "https://schema.org",
        "@type": "Drug",
        name: medicineDetail.getBasicInfoName(),
        nonProprietaryName: medicineDetail.getSimplifiedName(),
        activeIngredient: medicineDetail.getFormattedIngredientName(),
        isAvailableGenerically: medicineDetail.getEthicalType() === "일반의약품",
        isProprietary: medicineDetail.getEthicalType() === "전문의약품",
        prescriptionStatus: medicineDetail.getEthicalType() === "일반의약품" ? "https://schema.org/OTC" : "https://schema.org/PrescriptionOnly",
        warning: (ref = medicineDetail.getMedicineGuideCautions()) === null || ref === void 0 ? void 0 : ref.join(", "),
        identifier: {
            "@type": "PropertyValue",
            name: "Medicine ID",
            description: "DoctorNow Medicine Dictionary ID",
            value: medicineDetail.getPublicId()
        },
        image: medicineDetail.getRepresentativeImage(),
        brand: {
            "@type": "Organization",
            name: medicineDetail.getCompanyName()
        },
        recognizingAuthority: {
            "@type": "Organization",
            name: "식품의약품안전처",
            url: "https://uvoice.mfds.go.kr"
        },
        description: medicineDetail.getPharmaceuticalEffectLiteracy(),
        url: "".concat("https://doctornow.co.kr").concat((0,util/* createMedicineDictionaryDetailUrl */.at)(medicineDetail))
    };
};
var MedicineDictionaryDetailWithKeywordPage = function(param) {
    var client = param.client, publicId = param.publicId;
    var ref, ref1, ref2, ref3;
    var viewModel = medicine_dictionary_useMedicineDictionaryDetailViewModel({
        client: client,
        publicId: publicId
    });
    var topBannerViewModel = (0,useAppInstallTopBanner/* default */.Z)();
    var ldJson = createMedicineDictionaryDetailLdJson(viewModel.medicineDictionaryItemByPublicId);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(ldJson)
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "".concat((ref = viewModel.medicineDictionaryItemByPublicId) === null || ref === void 0 ? void 0 : ref.getBasicInfoName(), " 효능/효과, 부작용, 복용법 - 닥터나우 의약품 사전"),
                canonical: "".concat("https://doctornow.co.kr").concat((0,util/* createMedicineDictionaryDetailUrl */.at)(viewModel.medicineDictionaryItemByPublicId)),
                description: "".concat((ref1 = viewModel.medicineDictionaryItemByPublicId) === null || ref1 === void 0 ? void 0 : ref1.getPharmaceuticalEffectLiteracy(), " ").concat((ref2 = viewModel.medicineDictionaryItemByPublicId) === null || ref2 === void 0 ? void 0 : ref2.getSimplifiedName(), ". 효과부터 부작용, 복용법, 주의사항까지 ").concat((ref3 = viewModel.medicineDictionaryItemByPublicId) === null || ref3 === void 0 ? void 0 : ref3.getSimplifiedName(), "에 대한 정보를 닥터나우 의약품 사전에서 확인해보세요.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(medicine_dictionary_MedicineDictionaryDetailTemplate, {
                topBannerViewModel: topBannerViewModel,
                viewModel: viewModel,
                client: client
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _keyword_ = (MedicineDictionaryDetailWithKeywordPage);


/***/ }),

/***/ 45162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tq": function() { return /* binding */ AuthorType; },
/* harmony export */   "Zg": function() { return /* binding */ MagazineTagType; },
/* harmony export */   "pO": function() { return /* binding */ EDoctorCareer; },
/* harmony export */   "rL": function() { return /* binding */ MagazineType; },
/* harmony export */   "wK": function() { return /* binding */ MagazineBottomButtonType; }
/* harmony export */ });
/* unused harmony export CoreCategoryType */
var MagazineType = {
    INTERNAL: "INTERNAL",
    EXTERNAL: "EXTERNAL",
    ARTICLE: "ARTICLE",
    FAQ: "FAQ"
};
var MagazineTagType;
(function(MagazineTagType) {
    MagazineTagType["DEPARTMENT"] = "DEPARTMENT";
    MagazineTagType["SYMPTOM"] = "SYMPTOM";
    MagazineTagType["DISEASE"] = "DISEASE";
    MagazineTagType["FREE"] = "FREE";
})(MagazineTagType || (MagazineTagType = {}));
var CoreCategoryType;
(function(CoreCategoryType) {
    CoreCategoryType["Department"] = "DEPARTMENT";
    CoreCategoryType["Disease"] = "DISEASE";
    CoreCategoryType["Symptom"] = "SYMPTOM";
})(CoreCategoryType || (CoreCategoryType = {}));
var AuthorType;
(function(AuthorType) {
    AuthorType["DOCTOR"] = "DOCTOR";
    AuthorType["AI"] = "AI";
    AuthorType["NURSE"] = "NURSE";
    AuthorType["MEDICAL_PROFESSIONAL_EDITOR"] = "MEDICAL_PROFESSIONAL_EDITOR";
    AuthorType["GENERAL_EDITOR"] = "GENERAL_EDITOR";
})(AuthorType || (AuthorType = {}));
var ProfessionalFieldType;
(function(ProfessionalFieldType) {
    ProfessionalFieldType["DEPARTMENT"] = "DEPARTMENT";
})(ProfessionalFieldType || (ProfessionalFieldType = {}));
var MagazineBottomButtonType;
(function(MagazineBottomButtonType) {
    MagazineBottomButtonType["QUESTION"] = "QUESTION";
    MagazineBottomButtonType["DIAGNOSIS"] = "DIAGNOSIS";
})(MagazineBottomButtonType || (MagazineBottomButtonType = {}));
var EDoctorCareer;
(function(EDoctorCareer) {
    EDoctorCareer["CURRENT"] = "CURRENT";
    EDoctorCareer["PAST"] = "PAST";
    EDoctorCareer["GRADUATION"] = "GRADUATION";
    EDoctorCareer["COMPLETION"] = "COMPLETION";
})(EDoctorCareer || (EDoctorCareer = {}));


/***/ }),

/***/ 50728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$p": function() { return /* binding */ EGeneralSearchFeatureType; },
/* harmony export */   "Bf": function() { return /* binding */ EQuestionAccessibleType; },
/* harmony export */   "DD": function() { return /* binding */ EIntegratedSearchTabType; },
/* harmony export */   "Dp": function() { return /* binding */ EGeneralSearchSnippetType; },
/* harmony export */   "E": function() { return /* binding */ ERequestButtonType; },
/* harmony export */   "nc": function() { return /* binding */ EAuthorType; }
/* harmony export */ });
/* unused harmony exports EQuestionAnsweredStatus, EProfessionalFieldType, EAnswererType, EAnswerLikeType */
var EAuthorType;
(function(EAuthorType) {
    EAuthorType["Ai"] = "AI";
    EAuthorType["Doctor"] = "DOCTOR";
    EAuthorType["GeneralEditor"] = "GENERAL_EDITOR";
    EAuthorType["MedicalProfessionalEditor"] = "MEDICAL_PROFESSIONAL_EDITOR";
    EAuthorType["Nurse"] = "NURSE";
})(EAuthorType || (EAuthorType = {}));
var EQuestionAnsweredStatus;
(function(EQuestionAnsweredStatus) {
    EQuestionAnsweredStatus["Answered"] = "ANSWERED";
    EQuestionAnsweredStatus["Answering"] = "ANSWERING";
    EQuestionAnsweredStatus["Checking"] = "CHECKING";
})(EQuestionAnsweredStatus || (EQuestionAnsweredStatus = {}));
var EProfessionalFieldType;
(function(EProfessionalFieldType) {
    EProfessionalFieldType["Department"] = "DEPARTMENT";
})(EProfessionalFieldType || (EProfessionalFieldType = {}));
var EQuestionAccessibleType;
(function(EQuestionAccessibleType) {
    EQuestionAccessibleType["All"] = "ALL";
    EQuestionAccessibleType["DoctorsAndMe"] = "DOCTORS_AND_ME";
    EQuestionAccessibleType["Me"] = "ME";
})(EQuestionAccessibleType || (EQuestionAccessibleType = {}));
var EAnswererType;
(function(EAnswererType) {
    EAnswererType["Ai"] = "AI";
    EAnswererType["Doctor"] = "DOCTOR";
    EAnswererType["Nurse"] = "NURSE";
})(EAnswererType || (EAnswererType = {}));
var EAnswerLikeType;
(function(EAnswerLikeType) {
    EAnswerLikeType["Dislike"] = "DISLIKE";
    EAnswerLikeType["Like"] = "LIKE";
})(EAnswerLikeType || (EAnswerLikeType = {}));
var EIntegratedSearchTabType;
(function(EIntegratedSearchTabType) {
    EIntegratedSearchTabType["All"] = "ALL";
    EIntegratedSearchTabType["Qna"] = "QNA";
    EIntegratedSearchTabType["Magazine"] = "MAGAZINE";
    EIntegratedSearchTabType["Doctor"] = "DOCTOR";
    EIntegratedSearchTabType["Hospital"] = "HOSPITAL";
    EIntegratedSearchTabType["MedicineDictionary"] = "MEDICINE_DICTIONARY";
    EIntegratedSearchTabType["DiseaseEncyclopedia"] = "DISEASE_ENCYCLOPEDIA";
})(EIntegratedSearchTabType || (EIntegratedSearchTabType = {}));
var ERequestButtonType;
(function(ERequestButtonType) {
    ERequestButtonType["BOTTOM"] = "bottom";
    ERequestButtonType["FLOATING"] = "floating";
})(ERequestButtonType || (ERequestButtonType = {}));
var EGeneralSearchSnippetType;
(function(EGeneralSearchSnippetType) {
    EGeneralSearchSnippetType["DeliveryGuide"] = "DELIVERY_GUIDE";
    EGeneralSearchSnippetType["FaceToFaceDiagnosis"] = "FACE_TO_FACE_DIAGNOSIS";
    EGeneralSearchSnippetType["FaceToFacePrescription"] = "FACE_TO_FACE_PRESCRIPTION";
    EGeneralSearchSnippetType["NonFaceToFaceDiagnosis"] = "NON_FACE_TO_FACE_DIAGNOSIS";
    EGeneralSearchSnippetType["NonFaceToFacePrescription"] = "NON_FACE_TO_FACE_PRESCRIPTION";
})(EGeneralSearchSnippetType || (EGeneralSearchSnippetType = {}));
var EGeneralSearchFeatureType;
(function(EGeneralSearchFeatureType) {
    EGeneralSearchFeatureType["DietInjection"] = "DIET_INJECTION";
    EGeneralSearchFeatureType["EmergencyContraceptive"] = "EMERGENCY_CONTRACEPTIVE";
    EGeneralSearchFeatureType["FindPharmacy"] = "FIND_PHARMACY";
})(EGeneralSearchFeatureType || (EGeneralSearchFeatureType = {}));


/***/ }),

/***/ 48228:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ useMutation; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useSyncExternalStore.mjs
var useSyncExternalStore = __webpack_require__(464);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(32161);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/mutation.mjs
var mutation = __webpack_require__(89886);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/notifyManager.mjs
var notifyManager = __webpack_require__(30081);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/subscribable.mjs
var subscribable = __webpack_require__(33989);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/mutationObserver.mjs





// CLASS
class MutationObserver extends subscribable/* Subscribable */.l {
  constructor(client, options) {
    super();
    this.client = client;
    this.setOptions(options);
    this.bindMethods();
    this.updateResult();
  }

  bindMethods() {
    this.mutate = this.mutate.bind(this);
    this.reset = this.reset.bind(this);
  }

  setOptions(options) {
    const prevOptions = this.options;
    this.options = this.client.defaultMutationOptions(options);

    if (!(0,utils/* shallowEqualObjects */.VS)(prevOptions, this.options)) {
      this.client.getMutationCache().notify({
        type: 'observerOptionsUpdated',
        mutation: this.currentMutation,
        observer: this
      });
    }
  }

  onUnsubscribe() {
    if (!this.listeners.length) {
      var _this$currentMutation;

      (_this$currentMutation = this.currentMutation) == null ? void 0 : _this$currentMutation.removeObserver(this);
    }
  }

  onMutationUpdate(action) {
    this.updateResult(); // Determine which callbacks to trigger

    const notifyOptions = {
      listeners: true
    };

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error') {
      notifyOptions.onError = true;
    }

    this.notify(notifyOptions);
  }

  getCurrentResult() {
    return this.currentResult;
  }

  reset() {
    this.currentMutation = undefined;
    this.updateResult();
    this.notify({
      listeners: true
    });
  }

  mutate(variables, options) {
    this.mutateOptions = options;

    if (this.currentMutation) {
      this.currentMutation.removeObserver(this);
    }

    this.currentMutation = this.client.getMutationCache().build(this.client, { ...this.options,
      variables: typeof variables !== 'undefined' ? variables : this.options.variables
    });
    this.currentMutation.addObserver(this);
    return this.currentMutation.execute();
  }

  updateResult() {
    const state = this.currentMutation ? this.currentMutation.state : (0,mutation/* getDefaultState */.R)();
    const result = { ...state,
      isLoading: state.status === 'loading',
      isSuccess: state.status === 'success',
      isError: state.status === 'error',
      isIdle: state.status === 'idle',
      mutate: this.mutate,
      reset: this.reset
    };
    this.currentResult = result;
  }

  notify(options) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      // First trigger the mutate callbacks
      if (this.mutateOptions) {
        if (options.onSuccess) {
          var _this$mutateOptions$o, _this$mutateOptions, _this$mutateOptions$o2, _this$mutateOptions2;

          (_this$mutateOptions$o = (_this$mutateOptions = this.mutateOptions).onSuccess) == null ? void 0 : _this$mutateOptions$o.call(_this$mutateOptions, this.currentResult.data, this.currentResult.variables, this.currentResult.context);
          (_this$mutateOptions$o2 = (_this$mutateOptions2 = this.mutateOptions).onSettled) == null ? void 0 : _this$mutateOptions$o2.call(_this$mutateOptions2, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
        } else if (options.onError) {
          var _this$mutateOptions$o3, _this$mutateOptions3, _this$mutateOptions$o4, _this$mutateOptions4;

          (_this$mutateOptions$o3 = (_this$mutateOptions3 = this.mutateOptions).onError) == null ? void 0 : _this$mutateOptions$o3.call(_this$mutateOptions3, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
          (_this$mutateOptions$o4 = (_this$mutateOptions4 = this.mutateOptions).onSettled) == null ? void 0 : _this$mutateOptions$o4.call(_this$mutateOptions4, undefined, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
        }
      } // Then trigger the listeners


      if (options.listeners) {
        this.listeners.forEach(listener => {
          listener(this.currentResult);
        });
      }
    });
  }

}


//# sourceMappingURL=mutationObserver.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/utils.mjs
var lib_utils = __webpack_require__(24798);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs






function useMutation(arg1, arg2, arg3) {
  const options = (0,utils/* parseMutationArgs */.lV)(arg1, arg2, arg3);
  const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)({
    context: options.context
  });
  const [observer] = react.useState(() => new MutationObserver(queryClient, options));
  react.useEffect(() => {
    observer.setOptions(options);
  }, [observer, options]);
  const result = (0,useSyncExternalStore/* useSyncExternalStore */.$)(react.useCallback(onStoreChange => observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(onStoreChange)), [observer]), () => observer.getCurrentResult(), () => observer.getCurrentResult());
  const mutate = react.useCallback((variables, mutateOptions) => {
    observer.mutate(variables, mutateOptions).catch(noop);
  }, [observer]);

  if (result.error && (0,lib_utils/* shouldThrowError */.L)(observer.options.useErrorBoundary, [result.error])) {
    throw result.error;
  }

  return { ...result,
    mutate,
    mutateAsync: result.mutate
  };
} // eslint-disable-next-line @typescript-eslint/no-empty-function

function noop() {}


//# sourceMappingURL=useMutation.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1498,9653,1814,9774,2888,179], function() { return __webpack_exec__(94967); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);